<style >
    .titleogl{
        font-size: 16px;color: #115bb7;font-weight: bold;
    }
    .v-toolbar__title{
        color: #115bb7;font-weight: 500;
    }
    .theme--light.v-input {
        color: rgb(15, 119, 202);
    }
    .theme--light.v-label{
        color: #115bb7
    }
    .theme--light.v-select .v-select__selection--comma .theme--light.v-input input{
        color: #2f6894e6;   
    }
    .v-data-table td, .v-data-table th{
        padding: 0 5px;
    }
    .v-data-table td{
        font-size: 0.7rem;
    } 
    .v-card__subtitle, .v-card__text{
            letter-spacing: 0;
    }
    .v-application--is-ltr .v-data-footer__select .v-select{
            margin: 2px 0 5px 34px;
    }
    .v-input--radio-group--column .v-radio:not(:last-child):not(:only-child){
            margin-bottom:0px;
    }
    .v-text-field.v-text-field--enclosed .v-text-field__details{
        margin-bottom:0px;
    }
    .v-application .mr-2{
        margin-left: 8px !important;        
    }
    .v-application--is-ltr .v-textarea.v-text-field--enclosed .v-text-field__slot textarea{
        height: 90px;
    }
    .v-application .text-start{
        color: #000000;
        font-weight: 500;
    }
    .theme--light.v-data-table tbody tr:last-child td {
        border-right: thin solid #e1e5eb;
        padding: 0.25rem .5rem;
    }
    .theme--light.v-data-table tbody tr:not(:last-child) td:not(.v-data-table__mobile-row){
        border-bottom: thin solid #e1e5eb;
        border-right: thin solid #e1e5eb;
        padding: 0.25rem .5rem;
    }
    i.v-icon.notranslate.v-icon--link.material-icons.theme--light:focus {
        outline: #07b2ff 1px;
        background: #35c0ff;
    }
    i.v-icon.notranslate.v-icon--link.material-icons.theme--light:hover{
        box-shadow: 0px 3px 5px 2px rgba(6, 64, 86, 0.14);
    }
    .theme--light.v-data-table tbody tr:hover:not(.v-data-table__expanded__content) {
        background: #eceff147;
    }
    .theme--light.v-data-table thead tr th{
        color: #37474F;
        font-weight: 500;
    }
    .v-btn-toggle > .v-btn.v-btn--active span{
        color: white;
    } 
    .v-application .primary--text > span{
        color: #E91E63 !important;
    }
    .theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th{
        color: rgb(5 63 140);
        font-weight: 600;
    }
    .theme--light.v-data-table tbody tr:not(:last-child) td:not(.v-data-table__mobile-row){
        padding: 0.08rem .08rem;
    }
    .v-data-table > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > td, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td{
        color: black;
        font-weight: 500;
        font-size: 0.72rem;
    }
</style>
<template  style="background: #f5f5f5;">
    <v-form
        ref="form"
        v-model="valid"
        lazy-validation
        style="height: 100%;width: 100%;"
    >
        <v-container fluid>
            <v-layout style="flex-direction: column;" >
                <v-row style="margin-bottom: 6px;">
                    <v-col >
                        <v-flex >
                            <v-data-table
                            :headers="HeaderBuySellLista"
                            :items="BuySellLista"        
                            :search="search"
                            class="elevation-3"
                            style="border-radius: 6px;"
                            id="TableBuy"
                            :loading="loadigtable"
                            loading-text="Loading... Please wait"
                            :footer-props="{
                                showFirstLastPage: true,
                                firstIcon: 'skip_previous',
                                lastIcon: 'skip_next',
                                prevIcon: 'keyboard_arrow_left',
                                nextIcon: 'keyboard_arrow_right'
                            }"
                            >                     
                            <template v-slot:top>
                                <v-toolbar flat color="white">
                                    <v-toolbar-title>Buying and Selling search</v-toolbar-title>
                                    <v-divider
                                        class="mx-4"
                                        inset
                                        vertical
                                    ></v-divider>
                                    <v-spacer></v-spacer>
                                    <v-text-field class="text-xs-center" v-model="search" append-icon="search" label="Búsqueda" single-line hide-details></v-text-field>
                                    <v-spacer></v-spacer>
                                    <v-select style="margin-top: 15px;" v-if="$store.state.usuario.rol == 'ComercialAdmin' || $store.state.usuario.rol == 'Administrador' || $store.state.usuario.rol == 'Marketing'|| $store.state.usuario.rol == 'Finanzas'" label="Ejecutivo" v-model="idejecutivo" dense outlined :items="ejecutivos" v-on:change="buscarejecutivo(),mostrarcampos = false"></v-select>
                                    <v-btn style="margin-left: 8px;" color="primary" @click="nuevabs(), mostrarcampos = !mostrarcampos,idejecutivo = 0">New B's</v-btn>
                                    <!--<v-btn icon @click="nuevabs(),mostrarcampos = false,listar()"><v-icon>refresh</v-icon></v-btn>-->
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">                    
                                            <v-icon
                                            v-bind="attrs"
                                            v-on="on"
                                                class="mr-2"
                                                @click="nuevabs(),select(),listar()"
                                                style="color: #1583da;font-weight: 600;"
                                                >
                                                refresh
                                            </v-icon>
                                        </template>
                                        <span>Refresh</span>
                                    </v-tooltip>
                                </v-toolbar>
                            </template>
                            <template v-slot:[`item.opciones`]="{ item }">
                                    <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">                    
                                        <v-icon
                                        v-bind="attrs"
                                        v-on="on"
                                            small
                                            class="mr-2"
                                            @click="editItemBS(item)" 
                                            style="padding: 4px;border: 1px solid #e1e5eb;border-radius: 3px;"
                                            color="#3d5170"
                                            >
                                            edit
                                        </v-icon>
                                    </template>
                                    <span>Edit</span>
                                </v-tooltip>
                            </template>
                            <template v-slot:[`item.nbuysell`]="{ item }">
                                    <span v-if="item.activo == 0" style="color: red;font-weight: 600;font-size: 0.675rem;">{{item.nbuysell}}</span>
                                    <span v-else  style="font-size: 0.675rem;">{{item.nbuysell}}</span>
                            </template>
                            <template v-slot:[`item.custumer`]="{ item }">
                                    <span v-if="item.activo == 0" style="color: red;font-weight: 600;font-size: 0.675rem;">{{item.custumer}}</span>
                                    <span v-else  style="font-size: 0.675rem;">{{item.custumer}}</span>
                            </template>
                            <template v-slot:[`item.tipoOp`]="{ item }">
                                    <span v-if="item.activo == 0" style="color: red;font-weight: 600;font-size: 0.675rem;">{{item.tipoOp}}</span>
                                    <span v-else  style="font-size: 0.675rem;">{{item.tipoOp}}</span>
                            </template>
                            <template v-slot:[`item.basis`]="{ item }">
                                    <span v-if="item.activo == 0" style="color: red;font-weight: 600;font-size: 0.675rem;">{{item.basis}}</span>
                                    <span v-else  style="font-size: 0.675rem;">{{item.basis}}</span>
                            </template>
                            <template v-slot:[`item.modalidad`]="{ item }">
                                    <span v-if="item.activo == 0" style="color: red;font-weight: 600;font-size: 0.675rem;">{{item.modalidad}}</span>
                                    <span v-else  style="font-size: 0.675rem;">{{item.modalidad}}</span>
                            </template>
                            <template v-slot:[`item.receipt`]="{ item }">
                                    <span v-if="item.activo == 0" style="color: red;font-weight: 600;font-size: 0.675rem;">
                                        <span v-if="item.receipt=='SELECT..'">-</span>
                                        <span v-else>{{item.receipt}}</span>
                                    </span>
                                    <span v-else  style="font-size: 0.675rem;">
                                        <span v-if="item.receipt=='SELECT..'">-</span>
                                         <span v-else>{{item.receipt}}</span>
                                    </span>
                            </template>
                            <template v-slot:[`item.loading`]="{ item }">
                                    <span v-if="item.activo == 0" style="color: red;font-weight: 600;font-size: 0.675rem;">
                                        <span v-if="item.loading=='SELECT..'">-</span>
                                        <span v-else>{{item.loading}}</span>
                                    </span>
                                    <span v-else  style="font-size: 0.675rem;">
                                        <span v-if="item.loading=='SELECT..'">-</span>
                                         <span v-else>{{item.loading}}</span>
                                    </span>
                            </template>
                            <template v-slot:[`item.discharge`]="{ item }">
                                    <span v-if="item.activo == 0" style="color: red;font-weight: 600;font-size: 0.675rem;">
                                        <span v-if="item.discharge=='SELECT..'">-</span>
                                        <span v-else>{{item.discharge}}</span>
                                    </span>
                                    <span v-else  style="font-size: 0.675rem;">
                                        <span v-if="item.discharge=='SELECT..'">-</span>
                                         <span v-else>{{item.discharge}}</span>
                                    </span>
                            </template>
                            <template v-slot:[`item.delivery`]="{ item }">
                                    <span v-if="item.activo == 0" style="color: red;font-weight: 600;font-size: 0.675rem;">
                                        <span v-if="item.delivery=='SELECT..'">-</span>
                                        <span v-else>{{item.delivery}}</span>
                                    </span>
                                    <span v-else  style="font-size: 0.675rem;">
                                        <span v-if="item.delivery=='SELECT..'">-</span>
                                         <span v-else>{{item.delivery}}</span>
                                    </span>
                            </template>                    
                            <template slot="no-data">
                                <v-btn colo="primary" @click="listar">Resetear</v-btn>
                            </template> 
                            </v-data-table>                        
                        </v-flex>
                    </v-col>
                </v-row>
                <v-row style="align-items: center;margin-top: 16px;" >
                    <v-col>
                        <v-expand-transition>
                            <v-card v-show="mostrarcampos"  width="100%" elevation="2">
                                <v-list-item two-line>
                                    <v-list-item-content style="padding: 0;">                                                        
                                        <v-toolbar flat color="white">
                                            <v-toolbar-title class="titleogl">Buying and Selling</v-toolbar-title>
                                            <v-divider class="mx-4" inset vertical></v-divider>
                                            <div>
                                                <div>
                                                    <v-toolbar-title v-if="activo == true" class="titleogl"><span>BS N°: </span>{{editBS.nbuysell}}</v-toolbar-title>
                                                </div>
                                                <div v-if="ncotizacion">
                                                    <v-toolbar-title v-if="activo == true" class="titleogl"><span># </span>{{ncotizacion}}</v-toolbar-title>
                                                </div>
                                            </div>

                                            <v-divider class="mx-4" inset vertical></v-divider>
                                            
                                            <v-alert
                                                v-if="activo == false"
                                                dense
                                                outlined
                                                type="error"
                                                style="margin-top:12px;"
                                            >
                                                <strong> {{editBS.nbuysell}} Cancelada</strong>
                                            </v-alert>
                                            <v-spacer></v-spacer>
                                            <!--<v-btn  color="primary" @click="viewcotizaciones = true;">Relacionar Cotizacion</v-btn>-->
                                            <v-text-field v-model="creadopor" v-if="editBS.nbuysell != ''" label="Executive" dense outlined disabled style="max-width: 250px;margin-top: 20px;font-size: 11px;" text="fecha editado"></v-text-field>
                                            <v-text-field v-model="editadopor" v-if="editBS.nbuysell != ''" label="Edited by" dense outlined disabled style="max-width: 250px;margin-top: 20px;margin-left: 15px;font-size: 11px;" text="fecha editado"></v-text-field>
                                            <v-btn style="margin-left:10px;" v-if="editBS.nbuysell != ''"  color="primary" @click="viewoscar()">View</v-btn>
                                        </v-toolbar>                                                              
                                        <v-list-item-subtitle style="margin-bottom: 10px;">* Campos obligatorios</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-dialog v-model="viewcotizaciones" width="70%">
                                    <v-card class="mx-auto"  elevation="10">
                                        <v-card-title>Buscar Cotizacion</v-card-title>
                                        <v-divider></v-divider> <br>
                                        <v-card-text>
                                            <v-row>
                                                <v-col>
                                                    <v-text-field label="Numero de Cotizacion" v-model="NumeroCotizacion" outlined dense></v-text-field>
                                                </v-col>
                                                <v-col>
                                                    <v-btn color="primary" @click="BuscarCotizacion(NumeroCotizacion,2)">Buscar</v-btn> 
                                                </v-col>
                                            </v-row>
                                            
                                        </v-card-text>
                                    </v-card>
                                </v-dialog>       
                                <v-card-text style="padding: 0 16px;">
                                    <v-row style="align-items: center;margin-top:8px;" >
                                        <v-col sm="4" md="2" lg="2">
                                            <v-select required :rules="[v => !!v || 'Modality is required']"  outlined dense v-model="editBS.idmodalidad" v-on:change="activar" label="*Modality" :items="modalidad">
                                            </v-select>                               
                                        </v-col>
                                        <v-col sm="4" md="2" lg="2" >
                                            <v-select required :rules="[v => !!v || 'Basis is required']" outlined dense :disabled="activarbasis" v-model="editBS.idbasis" v-on:change="activar" label="*Basis" :items="basis">
                                            </v-select>                            
                                        </v-col>
                                        <v-col sm="4" md="2" lg="2">
                                            <v-select required :rules="[v => !!v || 'Operation is required']" outlined dense v-model="editBS.idtipoOp" v-on:change="activar" label="*Operation type" :items="TipoOperacion"></v-select>
                                        </v-col>
                                        <v-col sm="6" md="6" lg="6" xl="6"  v-if="viewinland === false" style="padding-right: 0;display: flex;"><!--Inland-->
                                            <v-btn-toggle
                                                v-model="editBS.indland"
                                                tile
                                                color="blue"
                                                group
                                                dense
                                                style="border: 1px solid;margin-bottom: 12px;margin-right: 8px;"
                                                >
                                                <v-btn value="inland" @click="mostrarinland()">
                                                    Inland
                                                </v-btn>                                    
                                            </v-btn-toggle>
                                            <div v-if="indl" style="display:flex;">
                                                <v-select style="width: 160px;" outlined dense v-model="editBS.idinland" label="Inland" :items="inlands"></v-select>                                     
                                                <v-select style="width: 160px;margin-left: 8px;" outlined dense v-model="editBS.dentrodebl" label="* Dentro o fuera de BL" :items="bl"></v-select>
                                            </div>
                                        </v-col>                        
                                    </v-row>
                                    <v-row>
                                        <v-col><!--Opciones-->
                                            <v-btn-toggle
                                                v-model="optionsbutton"
                                                tile
                                                color="#055a7f"
                                                style="border: 1px solid;"
                                                dense
                                                group
                                                multiple>
                                                    <v-btn value="customs" >
                                                        Customs 
                                                    </v-btn>  
                                                    <v-btn value="vgm" v-if="activevgm === false"><!--solo aparecera en exportacion-->
                                                        VGM 
                                                    </v-btn>
                                                    <v-btn value="insurance">
                                                        INSURANCE
                                                    </v-btn>
                                                    <v-btn value="custody" v-if="activecust === false">
                                                        CUSTODY
                                                    </v-btn>
                                                    <v-btn value="transfer" v-if="activecust === false">
                                                        TRANSFER
                                                    </v-btn>                                      
                                            </v-btn-toggle>
                                        <!--<v-divider color="#055a7f" horizontal></v-divider>-->
                                        <v-spacer></v-spacer>
                                        </v-col>
                                    </v-row>
                                    <v-row style="padding: 20px 0 0;">
                                        <v-col md="6" lg="4" xl="4">
                                            <v-select required :rules="[v => !!v || 'Executive is required']" outlined dense v-model="editBS.idusuario" label="* Sales Executive" :items="usuarios"></v-select>
                                        </v-col>
                                    </v-row>
                                    <v-row style="padding: 5px 0 0;">
                                        <v-col md="6" lg="4" xl="4"><!--Custumer-->
                                            <v-select required :rules="[v => !!v || 'Customer is required']" outlined dense label="*Customer Name" v-model="editBS.idcustumer" :items="customer"></v-select>
                                        </v-col>
                                        <v-col md="6" lg="8" xl="6">
                                            <v-row>
                                                <v-col style="padding-right: 0;display: flex;"><!--Credit-->
                                                    <v-btn-toggle
                                                    v-model="editBS.btcredit"
                                                    tile
                                                    color="blue"
                                                    style="border: 1px solid;margin-bottom: 12px;margin-right: 8px;"
                                                    group    
                                                    dense                                 
                                                    >
                                                        <v-btn  @click="Credityes" value="credit" >
                                                            Credit
                                                        </v-btn>                                    
                                                    </v-btn-toggle>
                                                    <div v-if="credit">
                                                        <v-text-field type="number" min="0" :error="error" outlined dense v-model="editBS.creditDays" label="Days"></v-text-field>
                                                    </div>
                                                </v-col>
                                            </v-row>                            
                                        </v-col>
                                    </v-row>
                                    <v-row>                        
                                        <v-col md="4" lg="4" xl="4"><!--Commodity-->
                                            <v-text-field outlined dense v-model="editBS.commodity" label="Commodity"></v-text-field>
                                        </v-col>
                                        <v-col  md="3" lg="3" xl="3" v-if="viewfahscode === false"><!--Fahscode-->
                                            <v-text-field outlined dense v-model="editBS.fahscode" label="F.A / H.S CODE "></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row >
                                        <v-col md="7" lg="7" xl="7" style="display:flex"><!--Hazardous-->
                                            <v-btn-toggle
                                                v-model="editBS.btnhazardous"
                                                tile
                                                color="#ce1507"
                                                style="margin-bottom: 12px;margin-right: 8px;border: 1px solid;"
                                                group     
                                                dense                                
                                                >
                                                <v-btn  @click="mostrarhazardous" value="hazardous" >
                                                    Hazardous 
                                                </v-btn>                                                                             
                                            </v-btn-toggle>
                                            <div v-if="harz" style="display:flex">
                                                <v-text-field outlined dense v-model="editBS.class1" label="CLASS"></v-text-field>
                                                <v-text-field outlined style="margin-left: 20px;" dense v-model="editBS.un" label="UN"></v-text-field>
                                            </div>
                                        </v-col>
                                    </v-row>
                                    <v-row style="margin-top: 8px;">
                                        <v-col  md="4" lg="4" xl="4">
                                            <v-select required :rules="[v => !!v || `*${titleprov}` + ' is required']" outlined dense v-model="editBS.idprovider" :label="`*${titleprov}`" :items="lineastransportistas"></v-select>
                                        </v-col>
                                        <v-col md="3" lg="3" xl="3" v-if="viewqt === false">
                                            <v-text-field outlined dense v-model="editBS.qt" label="QT"></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row style="flex-direction: column;">
                                        <v-col>
                                            <v-row>
                                                <v-col md="4" lg="4" xl="4" v-if="!inland">
                                                    <v-select required :rules="[v => !!v || 'Place of receipt / Pick Up is required']" outlined dense v-model="editBS.idportreceipt" label="*Place of receipt / Pick Up " :items="ports"></v-select>
                                                </v-col>
                                                <v-col md="2" lg="2" xl="2" v-if="!inland">
                                                    <v-menu
                                                        v-model="menuereceipt"
                                                        :close-on-content-click="false"
                                                        max-width="290"
                                                        dense
                                                        >
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-text-field
                                                            :value="computedDateFormatrecei"
                                                            clearable
                                                            label="*Date of pick up"
                                                            readonly
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            @click:clear="editBS.fechaareceipt = null"
                                                            dense
                                                            :rules="[v => !!v || 'Date pick up is required']"
                                                            ></v-text-field>
                                                        </template>
                                                        <v-date-picker
                                                            v-model="editBS.fechaareceipt"
                                                            @change="menuereceipt = false"
                                                        ></v-date-picker>
                                                    </v-menu> 
                                                </v-col>
                                            </v-row>
                                        </v-col>                        
                                        <v-col md="4" lg="4" xl="4" v-if="viewportloading === false">
                                            <v-row>
                                                <v-col >
                                                    <v-select required :rules="[v => !!v || `${titlePortloading}` + ' is required']"  outlined dense v-model="editBS.idportloading" :label="`*${titlePortloading}`" :items="ports"></v-select>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                        <v-col md="4" lg="4" xl="4" v-if="viewportdischarge === false">
                                            <v-row>
                                                <v-col >
                                                    <v-select required :rules="[v => !!v || `${titlePortdischarge}` + ' is required']" outlined dense v-model="editBS.idportdischarge" :label="`*${titlePortdischarge}`" :items="ports"></v-select>
                                                </v-col>
                                                <v-col v-if="!viewportloading === false">
                                                    <v-menu
                                                        v-model="menudeliviry"
                                                        :close-on-content-click="false"
                                                        max-width="290"
                                                        dense
                                                        >
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-text-field
                                                            :value="computedDateFormattdeli"
                                                            clearable
                                                            label="*Date pick up"
                                                            readonly
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            @click:clear="editBS.datedeliviry = null"
                                                            dense
                                                            required
                                                            :rules="[v => !!v || 'Date pick up is required']"
                                                            ></v-text-field>
                                                        </template>
                                                        <v-date-picker
                                                            v-model="editBS.datedeliviry"
                                                            @change="menudeliviry = false"
                                                        ></v-date-picker>
                                                    </v-menu>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                        <v-col>
                                            <v-row>
                                                <v-col md="4" lg="4" xl="4" v-if="!inland">
                                                    <v-select required :rules="[v => !!v || 'Place of Delivery is required']" outlined dense v-model="editBS.idportdelivery" label="*Place of Delivery " :items="ports"></v-select>
                                                </v-col>
                                                <v-col md="2" lg="2" xl="2" v-if="!viewportdischarge === false">
                                                    <v-menu
                                                    v-model="menudeliviry"
                                                    :close-on-content-click="false"
                                                    max-width="290"
                                                    dense
                                                    >
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-text-field
                                                            :value="computedDateFormattdeli"
                                                            clearable
                                                            label="*Date of delivery"
                                                            readonly
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            @click:clear="editBS.fechadelivery = null"
                                                            dense
                                                            required
                                                            :rules="[v => !!v || 'Delivery date is required or must be greater than the collection date']"
                                                            ></v-text-field>
                                                        </template>
                                                        <v-date-picker
                                                            v-model="editBS.fechadelivery"
                                                            @change="menudeliviry = false"
                                                        ></v-date-picker>
                                                    </v-menu> 
                                                </v-col>
                                            </v-row>
                                        </v-col>                        
                                    </v-row>
                                    <v-row v-if="viewfreedays === false">
                                        <v-col>                            
                                            <span class="titleogl">Free days of demurrage</span>
                                        </v-col>
                                    </v-row>
                                    <v-row style="text-align: center;color: #37474F;font-weight: bold;" v-if="viewfreedays === false">                        
                                        <v-col sm="2" md="2" lg="2">
                                            <span >Buy</span>
                                        </v-col>
                                        <v-col  sm="2" md="2" lg="2">
                                            <span >Sell</span>
                                        </v-col>                        
                                    </v-row> 
                                    <v-row v-if="viewfreedays === false">                                              
                                        <v-col sm="2" md="2" lg="2">
                                            <v-text-field type="number" min="0" dense v-model="editBS.freedaysoriginB" outlined label="*Origin"></v-text-field>
                                        </v-col>
                                        <v-col sm="2" md="2" lg="2">
                                            <v-text-field type="number" min="0" dense v-model="editBS.freedaysoriginS" outlined label="*Origin"></v-text-field>
                                        </v-col>
                                        <v-col sm="3" md="3" lg="2">
                                            <v-select outlined dense v-model="editBS.idvessel" label="Vessel" :items="vessels"></v-select>
                                        </v-col>
                                        <v-col sm="3" md="3" lg="2">
                                            <v-text-field outlined dense v-model="editBS.voyage" label="Voyage"></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row v-if="viewfreedays === false">                        
                                        <v-col sm="2" md="2" lg="2">
                                            <v-text-field type="number" min="0" dense v-model="editBS.freedaysdestB" outlined label="*Destination"></v-text-field>
                                        </v-col>
                                        <v-col sm="2" md="2" lg="2">
                                            <v-text-field type="number" min="0" dense v-model="editBS.freedaysdestS" outlined label="*Destination"></v-text-field>
                                        </v-col>
                                        <v-col sm="3" md="3" lg="2">
                                            <v-menu
                                            v-model="menuetd"
                                            :close-on-content-click="false"
                                            max-width="290"
                                            dense
                                            >
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field
                                                    :value="computedDateFormattedd"
                                                    clearable
                                                    label="*ETD"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    @click:clear="editBS.fechaetd = null"
                                                    dense
                                                    outlined
                                                    required
                                                    :rules="[v => !!v || 'La fecha ETD es Obligatoria']"
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker
                                                    v-model="editBS.fechaetd"
                                                    @change="menuetd = false"
                                                ></v-date-picker>
                                            </v-menu>                       
                                        </v-col>
                                        <v-col sm="3" md="3" lg="2">
                                            <v-menu
                                            v-model="menueta"
                                            :close-on-content-click="false"
                                            max-width="290"
                                            dense
                                            >
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field
                                                    :value="computedDateFormatteda"
                                                    clearable
                                                    label="*ETA"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    @click:clear="editBS.fechaeta = null"
                                                    dense
                                                    outlined
                                                    required
                                                    :rules="[v => !!v || 'La fecha ETA es Obligatoria y debe ser mayor a ETD']"
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker
                                                    v-model="editBS.fechaeta"
                                                    @change="menueta = false"
                                                ></v-date-picker>
                                            </v-menu> 
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col sm="4" md="4" lg="4">
                                            <v-textarea
                                                outlined
                                                counter="600"
                                                name="input-7-4"
                                                label="Remarks"
                                                :rules="maxcaracteresremarks"
                                                v-model="editBS.remarks"
                                                dense
                                                auto-grow
                                            ></v-textarea>
                                        </v-col>
                                        <v-col sm="2" md="2" lg="2">
                                            <v-textarea
                                                outlined
                                                counter="200"
                                                name="input-7-4"
                                                label="Reference"
                                                :rules="maxcaracteresreference"
                                                v-model="editBS.reference"
                                                dense
                                                auto-grow
                                            ></v-textarea>
                                        </v-col>
                                        <v-col sm="2" md="2" lg="2">
                                            <v-select required :rules="[v => !!v || 'Forwarder Agent is required']" outlined dense v-model="editBS.idagent" label="*Forwarder Agent" :items="agents"></v-select>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-expand-transition>
                    </v-col>
                </v-row>
                <v-row style="align-items: center;margin-top: 16px;">
                    <v-col md="12">
                        <v-expand-transition>
                            <v-card  elevation="2" style="padding-bottom: 0;" dense><!--CONTAINER /-->
                                <v-card-text v-if="CONTAINER === true">
                                    <v-row>
                                        <v-col md="9">
                                            <span class="titleogl">CONTAINER</span>                                
                                            <v-row style="display: flex;align-items: center;" >
                                                    <v-col sm="7" md="7">
                                                        <span class="titleogl">{{titlec}}</span>
                                                    </v-col>
                                                    <v-col sm="3" md="3">
                                                        <v-select item-text="text" return-object item-value="value" v-model="editcontainer.peso" label="Expressed in" :items="Masa"></v-select>
                                                    </v-col>
                                                    <v-col sm="2" md="2" style="text-align: center;">
                                                        <v-btn color="primary" @click="agregar">ADD</v-btn>
                                                    </v-col>
                                                </v-row>
                                                <v-row style="align-items: center;margin-top:8px;">
                                                    <v-col sm="2" md="2">
                                                        <v-text-field type="number" dense v-model="editcontainer.quantity" label="*Quantity"></v-text-field>
                                                    </v-col>
                                                    <v-col sm="3" md="3">
                                                        <v-select prefix="*" dense return-object item-text="text" item-value="value" label="Container Size" v-model="editcontainer.idsize" :items="tamanoc"></v-select>
                                                    </v-col>
                                                    <v-col sm="3" md="3">
                                                        <v-select dense return-object item-text="text" item-value="value" label="* Container Type" v-model="editcontainer.idtype" :items="tipoc">                                                                
                                                        </v-select>
                                                    </v-col>
                                                    <v-col sm="4" md="4">
                                                        <v-text-field type="number" dense v-model="editcontainer.weight" :label="'*Weight in ' + editcontainer.peso.text"></v-text-field>
                                                    </v-col>
                                                </v-row>
                                            <v-row>
                                                <v-col>
                                                    <v-data-table
                                                        :headers="headersC"
                                                        :items="containers"                                            
                                                        class="elevation-1"
                                                        dense
                                                        >
                                                        <template slot="item" slot-scope="containers">
                                                            <tr v-if="containers.item.activo == true">
                                                                <td style="text-align: center">
                                                                    <v-tooltip top>
                                                                        <template v-slot:activator="{ on, attrs }">                    
                                                                            <v-icon
                                                                                v-bind="attrs"
                                                                                v-on="on"
                                                                                small
                                                                                class="mr-2"
                                                                                @click="editItemc(containers.item)"
                                                                                style="padding: 4px;border: 1px solid #e1e5eb;border-radius: 3px;"
                                                                                color="#3d5170"
                                                                                >
                                                                                edit
                                                                            </v-icon>
                                                                        </template>
                                                                        <span>Edit</span>
                                                                    </v-tooltip>
                                                                    <v-tooltip top>
                                                                        <template v-slot:activator="{ on, attrs }">                    
                                                                            <v-icon
                                                                                v-bind="attrs"
                                                                                v-on="on"
                                                                                small
                                                                                class="mr-2"
                                                                                @click="deleteItemc(containers.item)"
                                                                                style="padding: 4px;border: 1px solid #e1e5eb;border-radius: 3px;"
                                                                                color="#3d5170"
                                                                                >
                                                                                delete
                                                                            </v-icon>
                                                                        </template>
                                                                        <span>Delete</span>
                                                                    </v-tooltip>
                                                                </td>
                                                                <td style="text-align: center">{{containers.item.quantity}}</td>
                                                                <td style="text-align: center">{{containers.item.size}}</td>
                                                                <td style="text-align: center">{{containers.item.type}}</td>
                                                                <td style="text-align: center">{{containers.item.nweight}}</td>
                                                            </tr>
                                                        </template>  
                                                            <template v-slot:no-data>
                                                                <v-btn dense color="primary" @click="listar">Reset</v-btn>
                                                            </template>
                                                        </v-data-table>                              
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                                <v-card-text dense v-if="PACKAGES === true" ><!--PACKAGES-->
                                        <v-row style="align-items: center;">
                                            <v-col>
                                                <span class="titleogl" >PACKAGES</span>
                                            </v-col>
                                            <v-col>
                                                <v-select item-text="text" return-object item-value="value" v-model="editpackage.longitud" label="Expressed in" :items="Longitud"></v-select>
                                            </v-col>
                                            <v-col>
                                                <v-select item-text="text" return-object item-value="value" v-model="editpackage.peso" label="Expressed in" :items="Masa"></v-select>
                                            </v-col>
                                        </v-row>
                                        <v-row style="align-items: center;" >
                                            <v-col md="3">
                                                <v-text-field type="number" dense v-model="editpackage.quantity" label="*Quantity "></v-text-field>
                                            </v-col>
                                            <v-col md="4">
                                                <v-select item-text="text" return-object item-value="value" v-model="editpackage.idpackage" v-on:change="mostrarotro" dense label="*Type of packages" :items="selectpackage"></v-select>
                                            </v-col>  
                                            <v-col md="5" v-if="packageotro === true">
                                                <v-text-field dense v-model="editpackage.otropackage" label="*Type of Package"></v-text-field>
                                            </v-col>                                  
                                        </v-row>
                                        <v-row style="align-items: center;">
                                            <v-col md="2" style="padding-right: 0;color: #186184;font-weight: 600;font-size: 14px;">
                                                <span>Measures </span>
                                            </v-col>
                                            <v-col>
                                                <v-text-field v-model="editpackage.large" type="number" dense label="*Length"></v-text-field><!--+ editpackage.idpackage.text-->
                                            </v-col>
                                            <v-col>
                                                <v-text-field v-model="editpackage.width" type="number" dense label="*Width"></v-text-field>
                                            </v-col>
                                            <v-col>
                                                <v-text-field v-model="editpackage.high" type="number" dense label="*Heigh"></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row style="align-items: center;" >
                                            <v-col md="2" style="padding-right: 0;color: #186184;font-weight: 600;font-size: 14px;">
                                                <span>Stackable </span>
                                            </v-col>
                                            <v-col md="3">
                                                <v-btn-toggle
                                                v-model="editpackage.stackable"
                                                tile
                                                color="blue"
                                                group
                                                dense
                                                >
                                                    <v-btn value="yes">
                                                        Yes
                                                    </v-btn>
                                                    <v-btn value="no">
                                                        No
                                                    </v-btn>                                            
                                                </v-btn-toggle>
                                            </v-col>
                                            <v-col md="7">
                                                <v-text-field v-model="editpackage.weight" type="number" dense :label="'*Weight in ' + editpackage.peso.text"></v-text-field>
                                            </v-col>
                                            <v-col>
                                                <v-textarea
                                                v-model="editpackage.Notes"
                                                    outlined
                                                    name="input-7-4"
                                                    label="Remarks"
                                                ></v-textarea>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col style="text-align: end;margin-bottom: 12px;">
                                                <v-btn color="primary" @click="agregarpackage">ADD</v-btn>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col>
                                            <v-data-table
                                                :headers="headerpackage"
                                                :items="addpackages"
                                                :search="searchpackage"
                                                class="elevation-1" 
                                                >
                                                <template slot="item" slot-scope="addpackages">
                                                    <tr v-if="addpackages.item.activo == true">
                                                        <td style="text-align: center">
                                                            <v-tooltip top>
                                                                <template v-slot:activator="{ on, attrs }">                    
                                                                    <v-icon
                                                                        v-bind="attrs"
                                                                        v-on="on"
                                                                        small
                                                                        class="mr-2"
                                                                        @click="editItempackage(addpackages.item)"
                                                                        style="padding: 4px;border: 1px solid #e1e5eb;border-radius: 3px;"
                                                                        color="#3d5170"
                                                                        >
                                                                        edit
                                                                    </v-icon>
                                                                </template>
                                                                <span>Edit</span>
                                                            </v-tooltip>
                                                            <v-tooltip top>
                                                                <template v-slot:activator="{ on, attrs }">                    
                                                                    <v-icon
                                                                        v-bind="attrs"
                                                                        v-on="on"
                                                                        small
                                                                        class="mr-2"
                                                                        @click="deleteItempackage(addpackages.item)"
                                                                        style="padding: 4px;border: 1px solid #e1e5eb;border-radius: 3px;"
                                                                        color="#3d5170"
                                                                        >
                                                                        delete
                                                                    </v-icon>
                                                                </template>
                                                                <span>Delete</span>
                                                            </v-tooltip>
                                                        </td>
                                                        <td style="text-align: center">{{addpackages.item.quantity}}</td>
                                                        <td style="text-align: center">{{addpackages.item.package}}</td>
                                                        <td style="text-align: center">{{addpackages.item.nlarge}}</td>
                                                        <td style="text-align: center">{{addpackages.item.nwidth}}</td>
                                                        <td style="text-align: center">{{addpackages.item.nhigh}}</td>
                                                        <td style="text-align: center">{{addpackages.item.nweight}}</td>
                                                        <td style="text-align: center">{{addpackages.item.volumetricweight}}</td>
                                                        <td style="text-align: center">{{addpackages.item.actualweight}}</td>
                                                        <td style="text-align: center">
                                                            <div v-if="addpackages.item.nstackable === 'yes'" style="text-align: center;">
                                                                <v-icon
                                                                    small
                                                                    class="mr-2"
                                                                    style="padding: 4px;border: 1px solid rgb(29, 175, 128);border-radius: 3px;font-weight: 700;"
                                                                    color="rgb(29 175 128)"
                                                                    >
                                                                    check
                                                                </v-icon>
                                                            </div>
                                                            <div v-else style="text-align: center;">
                                                                <v-icon
                                                                    small
                                                                    class="mr-2"
                                                                    style="padding: 4px;border: 1px solid #d80808;border-radius: 3px;font-weight: 700;"
                                                                    color="#d80808"
                                                                    >
                                                                    clear
                                                                </v-icon>            
                                                            </div>                  
                                                        </td>
                                                        <!--<td style="text-align: center">{{addpackages.item.longitud}}</td>-->
                                                    </tr>
                                                </template>
                                                    <template slot="no-data">
                                                        <v-btn colo="primary" >Resetear</v-btn>
                                                    </template> 
                                            </v-data-table>  
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                <v-card-text dense v-if="viewunits === true"><!--UNITS-->
                                    <span class="titleogl">UNITS</span>                                
                                    <v-row style="align-items: center;">
                                        <v-col md="3">
                                            <v-text-field dense v-model="editcontainer.quantitylcl" label="Quantity "></v-text-field>
                                        </v-col>
                                        <v-col md="9">                                        
                                            <v-select dense label="Type"></v-select>
                                        </v-col>                                    
                                    </v-row>
                                    <v-row style="align-items: center;">
                                        <v-col md="2" style="padding-right: 0;color: #186184;font-weight: 600;">
                                            <span>Transfer</span>
                                        </v-col>
                                        <v-col  md="3">
                                            <v-btn-toggle
                                                v-model="transferftl"
                                                tile
                                                color="blue"
                                                group
                                                dense
                                                >
                                                <v-btn value="yes" >
                                                    Yes
                                                </v-btn>
                                                <v-btn value="no">
                                                    No
                                                </v-btn>                                            
                                            </v-btn-toggle>
                                        </v-col>
                                        <v-col >
                                            <v-select v-model="idprovtransfer" dense label="Provider"></v-select>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-expand-transition>                                                          
                    </v-col>
                </v-row>
                <v-row style="margin-top:8px;" v-if=" mostrarcampos === true"> 
                    <v-col>
                        <v-card elevation="2" >
                            <v-card-text > 
                                <span class="titleogl">Charges highlights</span>
                                <v-row dense style="margin-top: 16px;">
                                    <v-col sm="2" md="2" lg="2"><v-select outlined dense return-object item-text="text" item-value="value" label="*Type" v-model="editedbuysell.idinstance" :items="buys" v-on:change="cargarpt" ></v-select></v-col>
                                    <v-col sm="5" md="4" lg="4"><v-select outlined dense return-object item-text="text" item-value="value" label="* Description" v-model="editedbuysell.idcharge" :items="charges"></v-select></v-col>
                                    <v-col sm="2" md="1" lg="1"><v-btn dense color="primary" @click="agregarbs"><span>Add</span></v-btn></v-col>
                                </v-row>
                                <v-row style="align-items: center;" dense>
                                    <v-col sm="4" md="3" lg="3"><v-select outlined dense return-object item-text="text" item-value="value" label="* Provider/Entity" v-model="editedbuysell.idprovider" :items="provider"></v-select></v-col>
                                    <v-col sm="3" md="2" lg="2"><v-select outlined dense return-object item-text="text" item-value="value" label="* Currency" v-on:change="Tipocambio"  v-model="editedbuysell.idmoneda" :items="monedas"></v-select></v-col>
                                    <v-col sm="3" md="2" lg="2"><v-text-field outlined dense disabled regular label="* Rate Exchange" v-model="editedbuysell.idtipocambio"></v-text-field></v-col>
                                    <v-col sm="2" md="2" lg="2"><v-text-field type="number" min="0" outlined dense prefix="$" v-model="editedbuysell.rate" label="*Rate"></v-text-field></v-col>
                                    <v-col sm="1" md="1" lg="1"><v-select outlined dense return-object item-text="text" item-value="value" label="IVA" v-model="editedbuysell.idiva" :items="ivas"></v-select></v-col>
                                    <v-col sm="1" md="1" lg="1"><v-checkbox
                                        :disabled="activocobrar"
                                        style="text-align: center;"
                                        v-model="cobrarpesos"
                                        label="Cobrar/pagar MXN"
                                        ></v-checkbox></v-col>
                                </v-row>
                                <v-row style="align-items: baseline;" dense>
                                    <v-col sm="2" md="2" dense>
                                        <span>*Per</span>
                                        <v-radio-group dense v-model="editedbuysell.idper" :mandatory="false">
                                            <v-radio label="Prepaid" value="Prepaid"></v-radio>
                                            <v-radio label="Collect" value="Collect"></v-radio>
                                        </v-radio-group>
                                    </v-col>
                                    <v-col sm="2" md="2" dense>
                                        <span>*Payment by</span>
                                        <v-radio-group dense v-model="editedbuysell.payment" :mandatory="false">
                                            <v-radio :disabled="LclLtl" dense label="Shipment" value="shipment"></v-radio>
                                            <v-radio :disabled="LclLtl" dense label="Container(s)" value="container"></v-radio>
                                            <v-radio dense label="TON/m3" value="TON/m3"></v-radio>                                                
                                        </v-radio-group>
                                    </v-col>
                                    <v-col >
                                        <v-row>
                                            <v-col sm="2" md="2">
                                                <v-text-field :disabled="editedbuysell.payment != 'container'" label="number" type="number" v-model="editedbuysell.quantity" outlined dense></v-text-field>
                                            </v-col>
                                            <v-col  sm="4" md="3">
                                                <v-select  :disabled="editedbuysell.payment != 'container'" outlined dense return-object item-text="text" item-value="value" label="* Container Size" v-model="editedbuysell.idtamano" :items="tamanoc"></v-select>
                                            </v-col>
                                            <v-col sm="4" md="3">
                                                <v-select  :disabled="editedbuysell.payment != 'container'" outlined dense return-object item-text="text" item-value="value" label="* Container Type" v-model="editedbuysell.idcontenedor" :items="tipoc">                                                                
                                                </v-select>
                                            </v-col>
                                            <v-col sm="11" md="8">
                                                <v-textarea dense outlined v-model="editedbuysell.notas" label="Notes"></v-textarea>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <v-text-field disabled outlined v-model="idtotalsell" dense label="TOTAL SELL"></v-text-field>
                                    </v-col>
                                    <v-col>
                                        <v-text-field disabled outlined dense v-model="idtotalbuy" label="TOTAL BUY"></v-text-field>
                                    </v-col>
                                    <v-col>
                                        <v-text-field disabled outlined v-model="idtotal" dense label="PROFIT (sell-buy)"></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                        <v-card style="margin-top:8px;" elevation="2">
                            <v-card-text>
                                <v-row>
                                    <span style="font-weight: 600;color: #1565C0;width: 100%;font-size: smaller;margin-bottom: 5px;text-align: center;">CHARGES SELL DETAILS</span>
                                    <v-data-table
                                    :headers="headersbs"
                                    :items="buysells"        
                                    :search="searchs"
                                    style="width: 100%;"                                        
                                    >
                                        <template slot="item" slot-scope="buysells">
                                            <tr v-if="buysells.item.activo == true">
                                                <td>
                                                    <v-tooltip top>
                                                        <template v-slot:activator="{ on, attrs }">                    
                                                            <v-icon
                                                            v-bind="attrs"
                                                            v-on="on"
                                                                small
                                                                class="mr-2"
                                                                @click="editItemBSChS(buysells.item)"
                                                                style="padding: 3px;border: 1px solid #e1e5eb;border-radius: 3px;text-align: center;"
                                                                color="#3d5170"
                                                                >
                                                                edit
                                                            </v-icon>
                                                        </template>
                                                        <span>Edit</span>
                                                    </v-tooltip>
                                                    <v-tooltip top>
                                                        <template v-slot:activator="{ on, attrs }">                    
                                                            <v-icon
                                                                v-bind="attrs"
                                                                v-on="on"
                                                                small
                                                                class="mr-2"
                                                                @click="deletechargesell(buysells.item)"
                                                                style="padding: 3px;border: 1px solid #e1e5eb;border-radius: 3px;text-align: center;"
                                                                color="#3d5170"
                                                                >
                                                                delete
                                                            </v-icon>
                                                        </template>
                                                        <span>Delete</span>
                                                    </v-tooltip>
                                                </td>
                                                <td style="text-align: center">{{buysells.item.buysell}}</td>
                                                <td style="text-align: center">{{buysells.item.provider}}</td>
                                                <td style="text-align: center">{{buysells.item.charge}}</td>
                                                <td style="text-align: center">{{buysells.item.per}}</td>
                                                <td style="text-align: center">{{buysells.item.moneda}}</td>
                                                <td style="text-align: center">
                                                    <div v-if="buysells.item.cobrarenpesos == true">
                                                        <v-icon
                                                            small
                                                            class="mr-2"
                                                            style="padding: 4px;border: 1px solid rgb(29, 175, 128);border-radius: 3px;font-weight: 700;"
                                                            color="rgb(29 175 128)"
                                                            >
                                                            check
                                                        </v-icon>
                                                    </div>
                                                </td>
                                                <td style="text-align: center">{{buysells.item.prepaid}}</td>
                                                <td style="text-align: center">{{buysells.item.collect}}</td>
                                                <td style="text-align: center">{{buysells.item.notas}}</td>
                                                <td style="text-align: center">{{buysells.item.quantity}}</td>
                                                <td style="text-align: center">
                                                    <span v-if="buysells.item.tamanoc != 'SELECT..'">{{buysells.item.tamanoc}}</span>
                                                    <span v-else>-</span>
                                                </td>
                                                <td style="text-align: center">
                                                    <span v-if="buysells.item.tipoc != 'SELECT..'">{{buysells.item.tipoc}}</span>
                                                    <span v-else>-</span>
                                                </td>
                                                <td style="text-align: center">{{buysells.item.rate}}</td>
                                                <td style="text-align: center">{{buysells.item.iva}}</td>
                                                <td style="text-align: center">{{buysells.item.total}}</td>
                                            </tr>
                                        </template> 
                                    </v-data-table>
                                </v-row>
                            </v-card-text>
                        </v-card>
                        <v-card style="margin-top:8px;" elevation="2">
                            <v-card-text>
                                <v-row >
                                    <span style="font-weight: 600;font-size: smaller;color: #1565C0;width: 100%;margin-bottom: 5px;text-align: center;">CHARGES BUY DETAILS</span>
                                    <v-data-table
                                    :headers="headersbs"
                                    :items="buysellB"        
                                    :search="searchb"                                   
                                    style="width: 100%;"                                        
                                    >
                                    <template slot="item" slot-scope="buysellB">
                                        <tr v-if="buysellB.item.activo == true">
                                            <td>
                                                <v-tooltip top>
                                                    <template v-slot:activator="{ on, attrs }">                    
                                                        <v-icon
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            small
                                                            class="mr-2"
                                                            @click="editItemBSChB(buysellB.item)"
                                                            style="padding: 3px;border: 1px solid #e1e5eb;border-radius: 3px;text-align: center;"
                                                            color="#3d5170"
                                                            >
                                                            edit
                                                        </v-icon>
                                                    </template>
                                                    <span>Edit</span>
                                                </v-tooltip>
                                                <v-tooltip top>
                                                    <template v-slot:activator="{ on, attrs }">                    
                                                        <v-icon
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            small
                                                            class="mr-2"
                                                            @click="deletechargebuy(buysellB.item)"
                                                            style="padding: 3px;border: 1px solid #e1e5eb;border-radius: 3px;text-align: center;"
                                                            color="#3d5170"
                                                            >
                                                            delete
                                                        </v-icon>
                                                    </template>
                                                    <span>Delete</span>
                                                </v-tooltip>
                                            </td>
                                            <td style="text-align: center">{{buysellB.item.buysell}}</td>
                                            <td style="text-align: center">{{buysellB.item.provider}}</td>
                                            <td style="text-align: center">{{buysellB.item.charge}}</td>
                                            <td style="text-align: center">{{buysellB.item.per}}</td>
                                            <td style="text-align: center">{{buysellB.item.moneda}}</td>
                                            <td style="text-align: center">
                                                <div v-if="buysellB.item.cobrarenpesos == true">
                                                    <v-icon
                                                        small
                                                        class="mr-2"
                                                        style="padding: 4px;border: 1px solid rgb(29, 175, 128);border-radius: 3px;font-weight: 700;"
                                                        color="rgb(29 175 128)"
                                                        >
                                                        check
                                                    </v-icon>
                                                </div>
                                            </td>
                                            <td style="text-align: center">{{buysellB.item.prepaid}}</td>
                                            <td style="text-align: center">{{buysellB.item.collect}}</td>
                                            <td style="text-align: center">{{buysellB.item.notas}}</td>
                                            <td style="text-align: center">{{buysellB.item.quantity}}</td>
                                            <td style="text-align: center">
                                                <span v-if="buysellB.item.tamanoc != 'SELECT..'">{{buysellB.item.tamanoc}}</span>
                                                <span v-else>-</span>
                                            </td>
                                            <td style="text-align: center">
                                                <span v-if="buysellB.item.tipoc != 'SELECT..'">{{buysellB.item.tipoc}}</span>
                                                <span v-else>-</span>
                                            </td>
                                            <td style="text-align: center">{{buysellB.item.rate}}</td>
                                            <td style="text-align: center">{{buysellB.item.iva}}</td>
                                            <td style="text-align: center">{{buysellB.item.total}}</td>
                                        </tr>
                                    </template> 
                                    </v-data-table>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row> 
                <v-row style="text-align: center;margin-top: 6px;" v-if=" mostrarcampos === true">
                    <v-col v-if="!idejecutivo">
                        <v-btn color="primary" @click="guardar" :disabled="guardando" :loading="guardando">GUARDAR</v-btn>
                        <v-btn color="error" style="margin-left: 15px;" @click="Cancelar">Cancelar</v-btn>
                    </v-col>
                </v-row>
                <v-row style="text-align: center;margin-top: 12px;" v-if="this.$store.state.usuario.rol === 'Operaciones' && editBS.enoperacion === false || this.$store.state.usuario.rol === 'OpComercial' && editBS.enoperacion === false || this.$store.state.usuario.rol === 'Administrador' && editBS.enoperacion === false">
                    <v-col style="margin-bottom: 12px;" v-if="editedIndexbuys != -1">
                        <router-link  style="padding: 7px;background:rgb(7 74 128);color: white;border-radius: 4px;text-decoration: none;margin-right: 8px;-webkit-box-shadow: 0px 3px 5px 1px rgba(0,0,0,0.47);-moz-box-shadow: 0px 3px 5px 1px rgba(0,0,0,0.47);box-shadow: 0px 3px 5px 1px rgba(0,0,0,0.47);" :to="{ name: 'oscar', params: { idbuysell: editBS.idbs }}">Make Shipment</router-link>
                        <router-link style="padding: 7px;background: rgb(7 74 128);color: white;border-radius: 4px;text-decoration: none;-webkit-box-shadow: 0px 3px 5px 1px rgba(0,0,0,0.47);-moz-box-shadow: 0px 3px 5px 1px rgba(0,0,0,0.47);box-shadow: 0px 3px 5px 1px rgba(0,0,0,0.47);" :to="{ name: 'inland', params: { idbuysell: editBS.idbs }}">Make Inland</router-link>
                    </v-col>
                </v-row>
                <v-row>
                    <v-dialog
                    v-model="dialof"
                    scrollable
                    max-width="90%"
                    >
                        <v-card>
                            <v-toolbar>
                                <v-card-title>Pre View Oscar  </v-card-title>
                                <v-spacer></v-spacer>
                            </v-toolbar>
                            <v-divider></v-divider>
                            <v-card-text>
                                <div id="Impresion" style="width: 100%;color: black;padding: 12px;">
                                    <header style="width: 100%;">
                                        <table  style="width: 100%;">
                                            <tr>
                                                <td>
                                                    <div id="logo" >
                                                        <img style="width:140px" src="data:image/png;base64,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" id="imagen">
                                                        <br>
                                                    </div>            
                                                </td>
                                                <td>
                                                    <div id="fact" >
                                                        <table style="width: 100%;">
                                                            <tr>
                                                                <td style="text-align: end;">
                                                                    <span style="font-size: 12px;">Optima Global Logistics</span><br>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td style="text-align: end;">
                                                                    <span style="font-size: 12px;">{{name()}}</span><br>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td style="text-align: end;">
                                                                    <span style="font-size: 12px;">{{fechaHoy}}</span>
                                                                </td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </td>
                                            </tr>
                                        </table>
                                    </header>
                                    <br>
                                    <section style="width: 100%;">
                                        <table class="imprimir" style="width: 100%;border-collapse: collapse;font-size: 8pt;">
                                            <tr class="headeroscar">
                                                <td style="background-color: rgb(202,224,249);padding: 4px;font-weight: 500;border: 1px solid #74a7e0;">
                                                    <span>EXECUTIVE</span>
                                                </td>
                                                <td style="background-color: rgb(202,224,249);padding: 4px;font-weight: 500;border: 1px solid #74a7e0;">
                                                    <span>Bs Number.</span>
                                                </td>
                                                <td style="background-color: rgb(202,224,249);padding: 4px;font-weight: 500;border: 1px solid #74a7e0;">
                                                    <span v-if="editBS.idbasis == 3 || editBS.idbasis == 4">Inland N°.</span>
                                                    <span v-else>OSCAR N°.</span>
                                                </td>
                                                <td style="background-color: rgb(202,224,249);padding: 4px;font-weight: 500;border: 1px solid #74a7e0;">
                                                    <span>BASIS</span>
                                                </td>
                                                <td style="background-color: rgb(202,224,249);padding: 4px;font-weight: 500;border: 1px solid #74a7e0;">
                                                    <span>PLACE OF RECEIPT</span>
                                                </td>
                                                <td v-if="editBS.idbasis ==1  || editBS.idbasis == 2 || editBS.idbasis == 5" style="background-color: rgb(202,224,249);padding: 4px;font-weight: 500;border: 1px solid #74a7e0;">
                                                    <span>PORT OF LOADING</span>
                                                </td>
                                                <td style="background-color: rgb(202,224,249);padding: 4px;font-weight: 500;border: 1px solid #74a7e0;">
                                                    <span>POL ETD</span>
                                                </td>
                                                <td v-if="editBS.idbasis ==1  || editBS.idbasis == 2 || editBS.idbasis == 5" style="background-color: rgb(202,224,249);padding: 4px;font-weight: 500;border: 1px solid #74a7e0;">
                                                    <span>PORT OF DISCHARGE</span>
                                                </td>
                                                <td style="background-color: rgb(202,224,249);padding: 4px;font-weight: 500;border: 1px solid #74a7e0;">
                                                    <span>POD ETA</span>
                                                </td>
                                                <td style="background-color: rgb(202,224,249);padding: 4px;font-weight: 500;border: 1px solid #74a7e0;">
                                                    <span>PLACE OF DELIERY</span>
                                                </td>
                                                <!--<td>
                                                    <span>MODALITY</span>
                                                </td>-->
                                                <td v-if="editBS.idbasis ==1  || editBS.idbasis == 2 || editBS.idbasis == 5" style="background-color: rgb(202,224,249);padding: 4px;font-weight: 500;border: 1px solid #74a7e0;">
                                                    <span>VESSEL/VOYAGE</span>
                                                </td>
                                                <!--<td>
                                                    <span>VESSEL/VOYAGE TRANSHIPMENT.</span>
                                                </td>-->
                                                <td style="background-color: rgb(202,224,249);padding: 4px;font-weight: 500;border: 1px solid #74a7e0;">
                                                    <span>SHIPPENG LINE </span>
                                                </td>
                                                <td style="background-color: rgb(202,224,249);padding: 4px;font-weight: 500;border: 1px solid #74a7e0;">
                                                    <span>OPTIMA'S AGENT </span>
                                                </td>
                                            </tr>
                                            <tr class="headerinfo">
                                                <td style="padding: 4px;text-align: center;border: 1px solid #cae0f9;">
                                                    <span>{{editBS.nombreus}}</span>
                                                </td>
                                                <td style="padding: 4px;text-align: center;border: 1px solid #cae0f9;">
                                                    <span>{{editBS.nbuysell}}</span>
                                                </td>
                                                <td style="padding: 4px;text-align: center;border: 1px solid #cae0f9;">
                                                    <span>{{numoscar}}</span>
                                                </td>
                                                <td style="padding: 4px;text-align: center;border: 1px solid #cae0f9;">
                                                    <span>{{editBS.basis}}</span>
                                                </td>
                                                <td style="padding: 4px;text-align: center;border: 1px solid #cae0f9;">
                                                    <span>{{editBS.receipt}}</span>
                                                </td>
                                                <td v-if="editBS.idbasis ==1  || editBS.idbasis == 2 || editBS.idbasis == 5" style="padding: 4px;text-align: center;border: 1px solid #cae0f9;">
                                                    <span>{{editBS.loading}}</span>
                                                </td>
                                                <td style="padding: 4px;text-align: center;border: 1px solid #cae0f9;">
                                                    <span v-if="editBS.idbasis ==1  || editBS.idbasis == 2 || editBS.idbasis == 5">{{editBS.fechaetd}}</span>
                                                    <span v-else>{{editBS.fechaareceipt}}</span>
                                                </td>
                                                <td v-if="editBS.idbasis ==1  || editBS.idbasis == 2 || editBS.idbasis == 5" style="padding: 4px;text-align: center;border: 1px solid #cae0f9;">
                                                    <span>{{editBS.discharge}}</span>
                                                </td>
                                                <td style="padding: 4px;text-align: center;border: 1px solid #cae0f9;">
                                                    <span v-if="editBS.idbasis ==1  || editBS.idbasis == 2 || editBS.idbasis == 5">{{editBS.fechaeta}}</span>
                                                    <span v-else>{{editBS.fechadelivery}}</span>
                                                </td>
                                                <td style="padding: 4px;text-align: center;border: 1px solid #cae0f9;">
                                                    <span>{{editBS.delivery}}</span>
                                                </td>
                                                <!--<td>
                                                    <span></span>
                                                </td>-->
                                                <td v-if="editBS.idbasis ==1  || editBS.idbasis == 2 || editBS.idbasis == 5" style="padding: 4px;text-align: center;border: 1px solid #cae0f9;">
                                                    <span v-if="editBS.nvessel!='SELECT..'">{{editBS.nvessel}} / </span><span v-else>--</span> <span >{{editBS.voyage}}</span>
                                                </td>
                                                <!--<td>
                                                    <span></span>
                                                </td>-->
                                                <td style="padding: 4px;text-align: center;border: 1px solid #cae0f9;">
                                                     <span>{{editBS.nprovider}}</span>
                                                </td>
                                                <td style="padding: 4px;text-align: center;border: 1px solid #cae0f9;">
                                                    <span>{{editBS.nagent}}</span>
                                                </td>
                                            </tr>
                                        </table>
                                        <br>
                                        <div style="display: flex;">
                                            <v-simple-table style="width: 45%;border-collapse: collapse;font-size: 8pt;">
                                                <thead>
                                                    <th style="background-color: rgb(202,224,249);padding: 2px;font-weight: 500;border: 1px solid #74a7e0;"><span>REFERENCE</span></th>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td style="padding: 2px;text-align: center;border: 1px solid #cae0f9;">{{editBS.reference}}</td>
                                                    </tr>
                                                </tbody>
                                            </v-simple-table>
                                        </div><br>
                                        <div style="display: flex;">
                                            <v-simple-table style="width: 45%;border-collapse: collapse;font-size: 8pt;">
                                                <thead>
                                                    <th style="background-color: rgb(202,224,249);padding: 2px;font-weight: 500;border: 1px solid #74a7e0;"><span>CONTAINER NUMBER</span></th>
                                                    <th style="background-color: rgb(202,224,249);padding: 2px;font-weight: 500;border: 1px solid #74a7e0;">SIZE</th>   
                                                    <th style="background-color: rgb(202,224,249);padding: 2px;font-weight: 500;border: 1px solid #74a7e0;">TYPE</th>
                                                    <!--<th style="background-color: rgb(202,224,249);padding: 2px;font-weight: 500;border: 1px solid #74a7e0;">MBL</th>-->
                                                    <!--<th style="background-color: rgb(202,224,249);padding: 2px;font-weight: 500;border: 1px solid #74a7e0;">HBL</th>-->
                                                </thead>
                                                <tbody>
                                                    <tr v-for="det in tarifasListarinfo" :key="det.num">
                                                        <td v-if="det.size != 10" style="padding: 2px;text-align: center;border: 1px solid #cae0f9;">{{det.containernumber}}</td>
                                                        <td v-if="det.size != 10" style="padding: 2px;text-align: center;border: 1px solid #cae0f9;"><span v-if="det.size != 'SELECT..'">{{det.size}}</span><span v-else>-</span></td>
                                                        <td v-if="det.size != 10" style="padding: 2px;text-align: center;border: 1px solid #cae0f9;"><span v-if="det.size != 'SELECT..'">{{det.type}}</span><span v-else>-</span></td>
                                                        <!--<td v-if="det.size != 10" style="padding: 2px;text-align: center;border: 1px solid #cae0f9;">{{det.mbln}}</td>
                                                        <td v-if="det.size != 10" style="padding: 2px;text-align: center;border: 1px solid #cae0f9;">{{det.hbln}}</td>-->
                                                    </tr>
                                                </tbody>
                                            </v-simple-table>
                                        </div>
                                    </section>
                                    <section style="width: 100%;display: flex;justify-content: space-around;margin-top: 15px;margin-bottom: 16px;">
                                    <v-simple-table>
                                        <thead>
                                            <tr style="display: flex;">
                                                <th style="width: 250px;text-align: center;font-weight: 600;color: black;height: 20px;">
                                                    <span style="font-size: 11px;">TOTAL SELL</span>  
                                                </th>
                                                <th style="width: 250px;text-align: center;font-weight: 600;color: black;height: 20px;">
                                                    <span style="font-size: 11px;">TOTAL BUY</span>
                                                </th>
                                                <th style="width: 250px;text-align: center;font-weight: 600;color: black;height: 20px;">
                                                    <span style="font-size: 11px;">PROFIT (sell-buy)</span>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr style="display: flex;">
                                                <td style="width: 250px;text-align: center;font-weight: 600;color: black;display: flex;">
                                                    <span style="padding: 5px;border: 1px solid;width: 90%;font-size: 11px">$ {{totalsell}}</span>
                                                </td>
                                                <td style="width: 250px;text-align: center;font-weight: 600;color: black;display: flex;">
                                                    <span style="padding: 5px;border: 1px solid;width: 90%;font-size: 11px">$ {{totalbuy}}</span>
                                                </td>
                                                <td style="width: 250px;text-align: center;font-weight: 600;color: black;display: flex;">
                                                    <span style="padding: 5px;border: 1px solid;width: 90%;font-size: 11px">$ {{totalprofit}}</span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </v-simple-table>
                                </section>
                                <section style="width: 100%;display: flex;justify-content: space-around;margin-top: 15px;margin-bottom: 16px;">
                                    <v-simple-table>
                                        <thead>
                                            <tr style="display: flex;">
                                                <th style="font-size: 12px;width: 250px;text-align: center;font-weight: 600;color: black;height: 20px;">
                                                    <span style="font-size: 12px;">TOTAL SELL + IVA</span>  
                                                </th>
                                                <th style="font-size: 12px;width: 250px;text-align: center;font-weight: 600;color: black;height: 20px;">
                                                    <span style="font-size: 12px;">TOTAL BUY + IVA</span>
                                                </th>
                                                <th style="font-size: 12px;width: 250px;text-align: center;font-weight: 600;color: black;height: 20px;">
                                                    <span style="font-size: 12px;">PROFIT + IVA(sell-buy)</span>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr style="display: flex;">
                                                <td style="font-size: 12px;width: 250px;text-align: center;font-weight: 600;color: black;display: flex;">
                                                    <span style="font-size: 12px;padding: 5px;border: 1px solid;width: 90%;font-size: 11px">$ {{totalselliva}}</span>
                                                </td>
                                                <td style="font-size: 12px;width: 250px;text-align: center;font-weight: 600;color: black;display: flex;">
                                                    <span style="font-size: 12px;padding: 5px;border: 1px solid;width: 90%;font-size: 11px">$ {{totalbuyiva}}</span>
                                                </td>
                                                <td style="font-size: 12px;width: 250px;text-align: center;font-weight: 600;color: black;display: flex;">
                                                    <span style="font-size: 12px;padding: 5px;border: 1px solid;width: 90%;font-size: 11px">$ {{totalprofitiva}}</span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </v-simple-table>
                                </section>
                                    <section style="width: 100%;">
                                        <fieldset style="padding: 0 5px;border: 1px solid rgb(4 35 105);border-radius: 4px;color: rgb(4 35 105);text-align: center;font-size: 12px;">
                                            <legend><span style="font-weight: 600;">CHARGES SELL DETAILS</span><br></legend>
                                            <table class="imprimir" style="font-size: 12px;color: black;width: 100%;">
                                                <thead>
                                                    <tr class="head">
                                                        <th style="padding: 3px;font-size: 12px;border-bottom: 1px solid;border-right: 1px solid;border-top: 1px solid;border-left: 1px solid;">Type</th>
                                                        <th style="padding: 3px;font-size: 12px;border-bottom: 1px solid;border-right: 1px solid;border-top: 1px solid;">PROVIDER</th>
                                                        <th style="padding: 3px;font-size: 12px;border-bottom: 1px solid;border-right: 1px solid;border-top: 1px solid;">DESCRIPTION</th>
                                                        <th style="padding: 3px;font-size: 12px;border-bottom: 1px solid;border-right: 1px solid;border-top: 1px solid;">PER</th>
                                                        <th style="padding: 3px;font-size: 12px;border-bottom: 1px solid;border-right: 1px solid;border-top: 1px solid;">CURRENCY</th>
                                                        <th style="padding: 3px;font-size: 12px;border-bottom: 1px solid;border-right: 1px solid;border-top: 1px solid;">PREPAID</th>
                                                        <th style="padding: 3px;font-size: 12px;border-bottom: 1px solid;border-right: 1px solid;border-top: 1px solid;">COLLECT</th>
                                                        <th style="padding: 3px;font-size: 12px;border-bottom: 1px solid;border-right: 1px solid;border-top: 1px solid;">MXN</th>
                                                        <th style="padding: 3px;font-size: 12px;border-bottom: 1px solid;border-right: 1px solid;border-top: 1px solid;">NOTES</th>
                                                        <th style="padding: 3px;font-size: 12px;border-bottom: 1px solid;border-right: 1px solid;border-top: 1px solid;">#CONTAINER</th>
                                                        <th style="padding: 3px;font-size: 12px;border-bottom: 1px solid;border-right: 1px solid;border-top: 1px solid;">UNIT </th>
                                                        <!--<th style="border-bottom: 1px solid;border-right: 1px solid;border-top: 1px solid;">Rate Exchange</th>-->
                                                        <th style="padding: 3px;font-size: 12px;border-bottom: 1px solid;border-right: 1px solid;border-top: 1px solid;">IVA</th>
                                                        <th style="padding: 3px;font-size: 12px;border-bottom: 1px solid;border-right: 1px solid;border-top: 1px solid;">TOTAL</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="det in buysellst" :key="det.num">
                                                        <td style="padding: 3px;font-size: 12px;text-align:center;border-bottom: 1px solid;border-right: 1px solid;border-left: 1px solid;">{{det.buysell}}</td>
                                                        <td style="padding: 3px;font-size: 12px;text-align:center;border-bottom: 1px solid;border-right: 1px solid;">{{det.provider}}</td>
                                                        <td style="padding: 3px;font-size: 12px;text-align:center;border-bottom: 1px solid;border-right: 1px solid;">{{det.charge}}</td>
                                                        <td style="padding: 3px;font-size: 12px;text-align:center;border-bottom: 1px solid;border-right: 1px solid;">{{det.per}}</td>
                                                        <td style="padding: 3px;font-size: 12px;text-align:center;border-bottom: 1px solid;border-right: 1px solid;">{{det.moneda}}</td>
                                                        <td style="padding: 3px;font-size: 12px;text-align:center;border-bottom: 1px solid;border-right: 1px solid;">{{det.prepaid}}</td>
                                                        <td style="padding: 3px;font-size: 12px;text-align:center;border-bottom: 1px solid;border-right: 1px solid;">{{det.collect}}</td>
                                                        <td style="padding: 3px;font-size: 12px;text-align:center;border-bottom: 1px solid;border-right: 1px solid;">{{det.totalmxn}}</td>
                                                        <td style="padding: 3px;font-size: 12px;text-align:center;border-bottom: 1px solid;border-right: 1px solid;">{{det.notas}}</td>
                                                        <td style="padding: 3px;font-size: 12px;text-align:center;border-bottom: 1px solid;border-right: 1px solid;">{{det.quantity}}</td>
                                                        <td style="padding: 3px;font-size: 12px;text-align:center;border-bottom: 1px solid;border-right: 1px solid;"><span v-if="det.tamanoc != 'SELECT..'">{{det.tamanoc}}</span><span v-else>-</span>  <span v-if="det.tipoc != 'SELECT..'">{{det.tipoc}}</span><span v-else>-</span></td>
                                                        <!--<td style="text-align:center;border-bottom: 1px solid;border-right: 1px solid;">{{det.rate}}</td>-->
                                                        <td style="padding: 3px;font-size: 12px;text-align:center;border-bottom: 1px solid;border-right: 1px solid;">{{det.iva}}</td>
                                                        <td style="padding: 3px;font-size: 12px;text-align:center;border-bottom: 1px solid;border-right: 1px solid;">{{det.total}}</td>
                                                    </tr>
                                                </tbody>
                                            </table><br>
                                        </fieldset>
                                    </section><br>
                                    <section style="width: 100%;">
                                        <fieldset style="padding: 0 5px;border: 1px solid rgb(4 35 105);border-radius: 4px;color: rgb(4 35 105);text-align: center;font-size: 12px;">
                                            <legend><span style="font-weight: 600;">CHARGES BUY DETAILS</span><br></legend>
                                            <table class="imprimir" style="font-size: 12px;color: black;width: 100%;">
                                                <thead>
                                                    <tr class="head">
                                                        <th style="padding: 3px;font-size: 12px;border-bottom: 1px solid;border-right: 1px solid;border-top: 1px solid;border-left: 1px solid;">Type</th>
                                                        <th style="padding: 3px;font-size: 12px;border-bottom: 1px solid;border-right: 1px solid;border-top: 1px solid;">PROVIDER</th>
                                                        <th style="padding: 3px;font-size: 12px;border-bottom: 1px solid;border-right: 1px solid;border-top: 1px solid;">DESCRIPTION</th>
                                                        <th style="padding: 3px;font-size: 12px;border-bottom: 1px solid;border-right: 1px solid;border-top: 1px solid;">PER</th>
                                                        <th style="padding: 3px;font-size: 12px;border-bottom: 1px solid;border-right: 1px solid;border-top: 1px solid;">CURRENCY</th>
                                                        <th style="padding: 3px;font-size: 12px;border-bottom: 1px solid;border-right: 1px solid;border-top: 1px solid;">PREPAID</th>
                                                        <th style="padding: 3px;font-size: 12px;border-bottom: 1px solid;border-right: 1px solid;border-top: 1px solid;">COLLECT</th>
                                                        <th style="padding: 3px;font-size: 12px;border-bottom: 1px solid;border-right: 1px solid;border-top: 1px solid;">MXN</th>
                                                        <th style="padding: 3px;font-size: 12px;border-bottom: 1px solid;border-right: 1px solid;border-top: 1px solid;">NOTES</th>
                                                        <th style="padding: 3px;font-size: 12px;border-bottom: 1px solid;border-right: 1px solid;border-top: 1px solid;">#CONTAINER</th>
                                                        <th style="padding: 3px;font-size: 12px;border-bottom: 1px solid;border-right: 1px solid;border-top: 1px solid;">UNIT </th>
                                                        <!--<th style="border-bottom: 1px solid;border-right: 1px solid;border-top: 1px solid;">Rate Exchange</th>-->
                                                        <th style="padding: 3px;font-size: 12px;border-bottom: 1px solid;border-right: 1px solid;border-top: 1px solid;">IVA</th>
                                                        <th style="padding: 3px;font-size: 12px;border-bottom: 1px solid;border-right: 1px solid;border-top: 1px solid;">TOTAL</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="det in buysellBt" :key="det.num">
                                                        <td style="padding: 3px;font-size: 12px;text-align:center;border-bottom: 1px solid;border-right: 1px solid;border-left: 1px solid;">{{det.buysell}}</td>
                                                        <td style="padding: 3px;font-size: 12px;text-align:center;border-bottom: 1px solid;border-right: 1px solid;">{{det.provider}}</td>
                                                        <td style="padding: 3px;font-size: 12px;text-align:center;border-bottom: 1px solid;border-right: 1px solid;">{{det.charge}}</td>
                                                        <td style="padding: 3px;font-size: 12px;text-align:center;border-bottom: 1px solid;border-right: 1px solid;">{{det.per}}</td>
                                                        <td style="padding: 3px;font-size: 12px;text-align:center;border-bottom: 1px solid;border-right: 1px solid;">{{det.moneda}}</td>
                                                        <td style="padding: 3px;font-size: 12px;text-align:center;border-bottom: 1px solid;border-right: 1px solid;">{{det.prepaid}}</td>
                                                        <td style="padding: 3px;font-size: 12px;text-align:center;border-bottom: 1px solid;border-right: 1px solid;">{{det.collect}}</td>
                                                        <td style="padding: 3px;font-size: 12px;text-align:center;border-bottom: 1px solid;border-right: 1px solid;">{{det.totalmxn}}</td>
                                                        <td style="padding: 3px;font-size: 12px;text-align:center;border-bottom: 1px solid;border-right: 1px solid;">{{det.notas}}</td>
                                                        <td style="padding: 3px;font-size: 12px;text-align:center;border-bottom: 1px solid;border-right: 1px solid;">{{det.quantity}}</td>
                                                        <td style="padding: 3px;font-size: 12px;text-align:center;border-bottom: 1px solid;border-right: 1px solid;"><span v-if="det.tamanoc != 'SELECT..'">{{det.tamanoc}}</span><span v-else>-</span>   <span v-if="det.tipoc != 'SELECT..'">{{det.tipoc}}</span><span v-else>-</span></td>
                                                        <!--<td style="text-align:center;border-bottom: 1px solid;border-right: 1px solid;">{{det.rate}}</td>-->
                                                        <td style="padding: 3px;font-size: 12px;text-align:center;border-bottom: 1px solid;border-right: 1px solid;">{{det.iva}}</td>
                                                        <td style="padding: 3px;font-size: 12px;text-align:center;border-bottom: 1px solid;border-right: 1px solid;">{{det.total}}</td>
                                                    </tr>
                                                </tbody>
                                            </table><br>
                                        </fieldset>
                                    </section>
                                </div>
                            </v-card-text>                            
                        </v-card>
                    </v-dialog>
                    <v-dialog
                        v-model="dialodload"
                        hide-overlay
                        persistent
                        width="300"
                    >
                        <v-card 
                        color="primary"
                        dark
                        >
                            <v-card-text><br>
                                Please stand by
                            <v-progress-linear
                                indeterminate
                                color="white"
                                class="mb-0"
                            ></v-progress-linear>                    
                            </v-card-text>
                        </v-card>
                    </v-dialog>
                </v-row>
                <v-snackbar
                    v-model="snackbar"
                    bottom
                    :color="colorm"
                    timeout = 8000
                    top
                    vertical
                >
                    {{ mensaje }}
                    <template>
                        <v-btn dark text @click="snackbar = false">
                            Close
                        </v-btn>
                    </template>
                </v-snackbar>
            </v-layout>
        </v-container>
    </v-form>
</template>
<script>
import axios from 'axios'
export default {    
    data(){
        return{
            guardando: false, 
            ////////////MOSTRAR COTIZACIONES////////////////////
            viewcotizaciones:false,
            NumeroCotizacion:'',
            ///////////////////////////////
            //expand:false,
            maxcaracteresremarks: [v => v.length <= 600 || 'Max 600 characters'],
            maxcaracteresreference: [v => v.length <= 200 || 'Max 200 characters'],
            loadigtable:false,
            loadinginfo:false,
            searchpackage:'',
            totalprofit:0,
            totalbuy:0,
            totalsell:0,
            totalprofitiva:0,
            totalbuyiva:0,
            totalselliva:0,
            dialodload:false,
            fechaHoy:'',
            dialof:false,
            cobrarpesos:false,
            creadopor:'',
            editadopor:'',
            searchb:'',
            searchs:'',
            bl:[
                {text:'Dentro de BL',value:1},
                {text:'Fuera de BL',value:2},
            ],
            LclLtl:false,
            error:false,
            valid: true,
            Obligatorio:'*',
            titlec:'',
            CONTAINER:false,
            Buy:'',
            mensaje:'',
            snackbar:false, 
            colorm:'',
            consecutivobs:1,   
            buysells:[],
            buysellB:[],
            buysell:'',        
            editedbuysell:{
                idinstance:0,
                instance:'',
                idcharge:0,
                charge:'',
                idprovider:0,
                priovider:'',
                idmoneda:1,
                moneda:'',
                idtipocambio:1,
                idtc:1,
                rate:'',
                iva:'NA',
                ivacant:0,
                idiva:2,
                idper:'Prepaid',
                per:'',
                payment:'shipment',
                idtamano:0,
                tamanoc:'',
                idcontenedor:0,
                tipoc:'',
                notas:'',
                prepaid:0,
                collect:0,
                total:0,
                quantity:0,
                cobrarenpesos:false,
            },
            headersbs:[
                {text:'OPTIONS',value:'opciones',align:'center',width:100,sortable:false},
                {text:'TYPE',value:'buysell',align:'center',sortable:false},
                {text:'PROVIDER',value:'provider',align:'center',sortable:false},
                {text:'DESCRIPTION',value:'charge',align:'center',sortable:false},
                {text:'PER',value:'per',align:'center',sortable:false},
                {text:'CURRENCY',value:'moneda',align:'center',sortable:false},
                {text:'MXN',value:'cobrarpesos',align:'center',sortable:false},
                {text:'PREPAID',value:'prepaid',align:'center',sortable:false},
                {text:'COLLECT',value:'collect',align:'center',sortable:false},
                {text:'NOTES',value:'notas',align:'center',maxwidth:200,sortable:false},
                {text:'# CONTAINERS',value:'quantity',align:'center',maxwidth:200,sortable:false},
                {text:'CONTAINER SIZE',value:'tamanoc',align:'center',sortable:false},
                {text:'CONTAINER TYPE',value:'tipoc',align:'center',sortable:false},
                {text:'RATE EXCHAGE',value:'rate',align:'center',sortable:false},
                {text:'IVA',value:'iva',align:'center',sortable:false},
                {text:'TOTAL',value:'total',align:'center',sortable:false},
            ],            
            buys:[],            
            monedas:[],
            charges:[],            
            provider:[],            
            tipoc   :[],            
            tamanoc:[],
            menueta:false,
            menuetd:false,
            date:'',
            on:'',
            attrs:'',
            btnhazardous:'',
            btcredit:'',
            basis:[],
            idbasis:'',
            nombre:'',
            TipoOperacion:[],
            idtipoOp:'',
            inlands:[],
            inlandst:[],
            idinland:'',
            modalidad:[],
            customer:[],
            iddatos:'',
            Shipping:[],            
            optionsbutton:[],
            editBS:{
                ncotizacion:'',
                idusuario:0,
                idmodalidad:0,
                idbasis:0,
                idtipoOp:0,
                idinland:0,
                insurance:0,        
                customs:0,
                vgm:0,                
                idcustumer:0,
                btcredit:[],
                creditDays:'',
                commodity:'',
                fahscode:'',
                btnhazardous:[],
                hazardous:'',
                idprovider:71,
                qt:'',
                idportreceipt:26,
                datereceipt:null,
                idportloading:26,
                idportdischarge:26,
                idportdelivery:26,
                datedeliviry:null,
                freedaysoriginB:'',
                freedaysoriginS:'',
                idvessel:7,
                voyage:'',
                freedaysdestB:'',
                freedaysdestS:'',
                fechaeta:null,
                fechaetd:null,
                remarks:'',
                idagent:71,
                class1:'',           
                un:'',
                fechaareceipt:'',
                fechadelivery:'',
                reference:'',
                dentrodebl:1,
                enoperacion:false,
            },            
            inlandop:'',
            credit:false,
            harz:false,
            indl:false,
            headers: [
                { text: 'OPTIONS', value: 'opciones', sortable: false,align:'center' },        
                { text: 'QUANTITY', value: 'quantity', sortable: false,align:'center' },
                { text: 'TYPE PACKAGE', value: 'typePackage', sortable: false,align:'center' },
                { text: 'LENGTH', value: 'large', sortable: false,align:'center' },
                { text: 'WIDTH', value: 'width', sortable: false,align:'center' },
                { text: 'HEIGHT', value: 'high', sortable: false,align:'center' },
                { text: 'STACKABLE', value: 'stackable', sortable: false,align:'center' },
                { text: 'WEIGHT', value: 'weight', sortable: false,align:'center' },
                { text: 'VOL', value: 'vol', sortable: false,align:'center' }
            ],
            headersC: [
                { text: 'OPTIONS', value: 'opciones', sortable: false,align:'center' },
                { text: 'QUANTITY', value: 'quantity',align:'center' },
                { text: 'SIZE', value: 'size',align:'center' },
                { text: 'TYPE', value: 'type',align:'center' },
                { text: 'WEIGHT', value: 'nweight',align:'center' },
            ],
            containers:[],
            editcontainer:{
                idcontainer:0,
                quantity:'',
                peso:{text:'Kilo',value:1},  
                size:'',
                idunidadmasa:'',
                idsize:0,
                type:'',
                idtype:0,
                weight:'',
                nweight:'',
                remarks:'',
                weightsnconv:0,
                activo:true
            },
            Masa:[],
            editpackage:{
                longitud:{text:'Metro',value:1},
                peso:{text:'Kilo',value:1},
                stackable:0,
                nstackable:'',
                weight:'',
                nweight:'',
                high:'',
                width:'',
                large:'',
                nhigh:'',
                nwidth:'',
                nlarge:'',
                idpackage:0,
                quantity:'',
                otropackage:'',
                package:'',
                idlongitud:0,
                Notes:''
            },
            headerpackage:[
                {text:'OPTIONS',value:'opciones',align:'center',sortable:false},
                {text:'QUANTITY',value:'quantity',align:'center',sortable:false},
                {text:'PACKAGE',value:'package',align:'center',sortable:false},
                {text:'LENTH',value:'nlarge',align:'center',sortable:false},
                {text:'WIDTH',value:'nwidth',align:'center',sortable:false},
                {text:'HEIGHT',value:'nhigh',align:'center',sortable:false},
                {text:'WEIGHT',value:'nweight',align:'center',sortable:false},
                {text:'VOLUMETRIC WEIGHT',value:'volumetricweight',align:'center',sortable:false},
                {text:'ACTUAL WEIGHT',value:'actualweight',align:'center',sortable:false},
                {text:'STACKABLE',value:'nstackable',align:'center',sortable:false},
                //{text:'LONGITUD',value:'longitud',align:'center',sortable:false},
            ],
            addpackages:[],
            packageotro:false,
            Longitud:[],
            packageslcl:[],
            editedIndex: -1,
            editedIndexbs: -1,
            editedIndexc: -1,
            editedIndexbuys: -1,
            text:'',
            datedeliviry:'',
            menuereceipt:false,
            datereceipt:'',
            menudeliviry:false,
            PACKAGES:false,
            viewtransfer:false,
            UNITS:false,
            transferftl:'',
            ftl:false,
            ltl:false,
            titleprov:'Shipping Line',
            activevgm:false,
            activecust:false,
            inland:false,
            ftldate:true,
            lclview:false,
            aereo:false,
            btnhazardous:'',
            idmodalidad:'',
            ports:[],
            vessels:[],
            agents:[],
            tipo:'',
            ivas:[],
            consecutivo:[],
            search:'',
            Numconsecutivo:0,
            bsnum: '',
            cons:0,
            totalSell:0,
            totalBuy:0,
            idtotalsell:0,
            idtotalbuy:0,
            idtotal:0,
            iva:0,
            prepaid:0,
            collect:0,
            BuySellLista:[],
            HeaderBuySellLista:[
                {text:'',value:'opciones',align:'center'},
                {text:'BS NUMBER',value:'nbuysell',align:'center'},
                {text:'CUSTOMER NAME',value:'custumer',align:'center'},
                {text:'OPERATION TYPE',value:'tipoOp',align:'center'},
                {text:'BASIS',value:'basis',align:'center'},
                {text:'MODALITY',value:'modalidad',align:'center'},
                {text:'PLACE OF RECEIPT',value:'receipt',align:'center'},
                {text:'POL',value:'loading',align:'center'},
                {text:'POD',value:'discharge',align:'center'},
                {text:'FINAL DESTINATION',value:'delivery',align:'center'},
            ],
            idproviderpack:'',
            quantity:'',
            typePackage:'',
            large:'',
            width:'',
            high:'',
            weight:'',
            transfer:'',
            transfer1:0,
            stackable:'',
            titlePortloading:'Port of Loading',
            titlePortdischarge:'Port of Discharge',
            viewfreedays:false,
            viewinland:false,
            viewfahscode:false,
            viewqt:false,
            viewportdischarge:false,
            viewunits:false,
            viewportloading:false,
            viewprovidertranser:true,
            editedIndexp:-1,
            selectpackage:[],
            hazar:0,
            idtotalsell1:0,
            idtotalbuy1:0,
            idtotal1:0,
            editedIndexchb:-1,
            editedIndexchs:-1,
            activarbasis:true,
            usuarios:[],
            ivareturn:0,
            mostrarcampos:false,
            lineastransportistas:[],
            editedIndexpack:-1,
            idtc:1,
            activo:true,
            tarifasListarinfo :[],
            tarifasListar : [],
            infcontainers : [],
            numbercontainer:'',
            ncontainer:'',
            hblnum:'',
            mblhnl:[],
            numoscar:'Pendiente',
            buysellBt:[],
            buysellst:[],
            totalsell: 0,
            totalbuy: 0,
            totalprofit: 0,
            totalselliva: 0,
            totalbuyiva: 0,
            totalprofitiva: 0,
            costossell: [],
            valida:0,
            validaMensaje:[],
            activocobrar:true,
            viewoscarbs:false,
            viewbsbs:false,
            idejecutivo:0,
            ejecutivos:[],
            idcotizacion:0,
            ncotizacion:'',
            validabs:0,

        }        
    },
    computed: {
      computedDateFormatteda () {
          if(this.editBS.fechaeta > this.editBS.fechaetd){
              return this.formatDate(this.editBS.fechaeta)
          }
      },
      computedDateFormattedd () {
          if(this.indl == true){
              if(this.editBS.idportreceipt != 0 && this.editBS.idportreceipt  != 26){
                if(this.editBS.fechaetd >= this.editBS.fechaareceipt){
                    return this.formatDate(this.editBS.fechaetd);
                }
              }else{
                  return this.formatDate(this.editBS.fechaetd);
              }
          }else{
            return this.formatDate(this.editBS.fechaetd);
          }
      },
      computedDateFormattdeli () {
          if(this.editBS.fechadelivery >= this.editBS.fechaareceipt){
              return this.formatDate(this.editBS.fechadelivery);
          }
      },
      computedDateFormatrecei () {
        return this.formatDate(this.editBS.fechaareceipt);
      },
    },
    async created(){
        this.select();
        this.listar();     
        this.fechahoy();
        if(this.$route.params.idscotizacion != undefined){
             //this.BuscarBS();
             var idscotizacion = 0;
             var ncotizacion = 0;
             idscotizacion = this.$route.params.idscotizacion
             this.ncotizacion = this.$route.params.ncotizacion
             this.BuscarCotizacion(idscotizacion,1);
             
        }
    },
    methods:{
        name(){
            return this.$store.state.usuario.nombre + ' ' + this.$store.state.usuario.apellido;
        },
        fechahoy(){
            const date = new Date()
            const dateTimeFormat = new Intl.DateTimeFormat('Mx', { year: 'numeric', month: 'long', day: '2-digit' }) 
            const [{ value: month },,{ value: day },,{ value: year }] = dateTimeFormat .formatToParts(date ) 
            this.fechaHoy = `${month} de ${day} del ${year }`;
        },
        listar(){//mandamos llamar el controlador Categorias y asu accion Listar y guardamos la informacion que nos devuelve en la variable response
            this.loadigtable = true;
            this.limpiar();
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            //me.loadinginfo = true;
            me.BuySellLista = [];
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            if(this.$store.state.usuario.rol == 'Comercial' || this.$store.state.usuario.rol == 'Telemarketing' || this.$store.state.usuario.rol == 'PricingTerrestre' || this.$store.state.usuario.rol == 'PricingAgente' || this.$store.state.usuario.rol == 'Pricing' || this.$store.state.usuario.rol == 'ComercialAdmin' || this.$store.state.usuario.rol == 'ComercialAgente'){
                axios.get('api/Buysells/Listarus/' + this.$store.state.usuario.idusuario,configuracion).then(function(response){                
                    me.BuySellLista=response.data;
                    me.loadigtable = false;
                }).catch(function(error){
                    console.log(error);
                });
            }else{
                axios.get('api/Buysells/Listar',configuracion).then(function(response){                
                    me.BuySellLista=response.data;
                    me.loadigtable = false;
                }).catch(function(error){
                    console.log(error);
                });
            }      
        },
        buscarejecutivo(){//mandamos llamar el controlador Categorias y asu accion Listar y guardamos la informacion que nos devuelve en la variable response
            this.loadigtable = true;
            this.limpiar();
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            //me.loadinginfo = true;
            me.BuySellLista = [];
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            axios.get('api/Buysells/Listarus/' + this.idejecutivo,configuracion).then(function(response){                
                me.BuySellLista=response.data;
                me.loadigtable = false;
            }).catch(function(error){
                console.log(error);
            });   
        },
        select(){
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            var basiss = [];                
            var tipoOp = [];
            var inlandArray = [];
            var modalidadArray = [];
            var customerArray = [];
            var providerArray = [];
            var monedasArray = [];
            var chargesArray = [];
            var bsArray = [];
            var tamanocArray = [];
            var tipocArray = [];
            var portArray = [];
            var vesselArray = [];
            var agentArray = [];
            var ivaArray = [];
            var packageArray = [];
            var longitudArray = []; 
            var masaArray = [];
            var usuariosarray = [];
            var shippinarray = [];
            var usuariosarraysc = [];
            
            axios.get('api/Usuarios/SelectReportSC',configuracion).then(function(response){
                usuariosarraysc=response.data;
                usuariosarraysc.map(function(x){
                    me.ejecutivos.push({text:x.nombre,value:x.idusuario});
                });            
            }).catch(function(error){
                console.log(error);
            });

            axios.get('api/LineasTransportistas/Select',configuracion).then(function(response){
                shippinarray=response.data;
                shippinarray.map(function(x){
                    me.lineastransportistas.push({text:x.nombre,value:x.idlinea});
                });            
            }).catch(function(error){
                console.log(error);
            });
            axios.get('api/Usuarios/SelectBS',configuracion).then(function(response){
                usuariosarray=response.data;
                usuariosarray.map(function(x){
                    me.usuarios.push({text:x.nombre,value:x.idusuario});
                });            
            }).catch(function(error){
                console.log(error);
            });                
            axios.get('api/Unidadmedidalongitudes/Select',configuracion).then(function(response){            
                longitudArray=response.data;
                longitudArray.map(function(x){
                    me.Longitud.push({text:x.nombre,value:x.idunidad,idclave:x.idclave});
                });
            }).catch(function(error){
                console.log(error);
            });
            axios.get('api/Basis/Select',configuracion).then(function(response){            
                basiss=response.data;
                basiss.map(function(x){
                    me.basis.push({text:x.nombre,value:x.idbasis});
                });            
            }).catch(function(error){
            console.log(error);
            });
            axios.get('api/Unidadmedidamasas/Select',configuracion).then(function(response){            
                masaArray=response.data;
                masaArray.map(function(x){
                    me.Masa.push({text:x.nombre,value:x.idunidadmasa,idclave:x.idclave});
                });
            }).catch(function(error){
            console.log(error);
            });
            axios.get('api/Package/Select',configuracion).then(function(response){            
                packageArray=response.data;
                packageArray.map(function(x){
                    me.selectpackage.push({text:x.nombre,value:x.idpackage});
                });            
            }).catch(function(error){
                console.log(error);
            });
            axios.get('api/ivas/Select',configuracion).then(function(response){            
                ivaArray=response.data;
                ivaArray.map(function(x){
                    me.ivas.push({text:x.nombre + "%" ,value:x.idiva} );
                });            
            }).catch(function(error){
            console.log(error);
            });
            axios.get('api/Tipooperaciones/Select',configuracion).then(function(response){            
                tipoOp=response.data;
                tipoOp.map(function(x){
                    me.TipoOperacion.push({text:x.nombre,value:x.idtipoOp});
                });            
            }).catch(function(error){
                console.log(error);
            });
            axios.get('api/Inlands/Select',configuracion).then(function(response){            
                inlandArray=response.data;
                inlandArray.map(function(x){
                    me.inlands.push({text:x.nombre,value:x.idinland});
                });            
            }).catch(function(error){
                console.log(error);
            });
            axios.get('api/Modalidades/Select',configuracion).then(function(response){            
                modalidadArray=response.data;
                modalidadArray.map(function(x){
                    me.modalidad.push({text:x.nombre,value:x.idmodalidad});
                });            
            }).catch(function(error){
                console.log(error);
            });
            axios.get('api/Datos/SelectCliente',configuracion).then(function(response){            
                customerArray=response.data;
                customerArray.map(function(x){
                    me.customer.push({text:x.nombre,value:x.iddatos});
                });            
            }).catch(function(error){
                console.log(error);
            });
            axios.get('api/Datos/SelectProveedor',configuracion).then(function(response){            
                providerArray=response.data;
                providerArray.map(function(x){
                    me.provider.push({text:x.nombre,value:x.iddatos});
                });            
            }).catch(function(error){
                console.log(error);
            });
            axios.get('api/Monedas/select',configuracion).then(function(response){            
                monedasArray=response.data;
                monedasArray.map(function(x){
                    me.monedas.push({text:x.abreviatura,value:x.idmoneda});
                });            
            }).catch(function(error){
                console.log(error);
            });            
            axios.get('api/Charges/select',configuracion).then(function(response){            
                chargesArray=response.data;
                chargesArray.map(function(x){
                    me.charges.push({text:x.nombre,value:x.idcharge});
                });            
            }).catch(function(error){
                console.log(error);
            });
            axios.get('api/Instances/select',configuracion).then(function(response){            
                bsArray=response.data;
                bsArray.map(function(x){
                    me.buys.push({text:x.nombre,value:x.idinstance});
                });            
            }).catch(function(error){
                console.log(error);
            });
            axios.get('api/Tipocontenedores/select',configuracion).then(function(response){            
                tipocArray=response.data;
                tipocArray.map(function(x){
                    me.tipoc.push({text:x.tipocontenedor,value:x.idcontenedor});
                });            
            }).catch(function(error){
                console.log(error);
            });
            axios.get('api/tamanocontenedores/select',configuracion).then(function(response){            
                tamanocArray=response.data;
                tamanocArray.map(function(x){
                    me.tamanoc.push({text:x.tamanocontenedor,value:x.idtamano});
                });            
            }).catch(function(error){
                console.log(error);
            });
            axios.get('api/Puertos/select',configuracion).then(function(response){            
                portArray=response.data;
                portArray.map(function(x){
                    me.ports.push({text:x.nombre,value:x.idpuerto});
                });            
            }).catch(function(error){
                console.log(error);
            });
            axios.get('api/Vessels/select',configuracion).then(function(response){            
                vesselArray=response.data;
                vesselArray.map(function(x){
                    me.vessels.push({text:x.nombre,value:x.idvessel});
                });            
            }).catch(function(error){
                console.log(error);
            });
            axios.get('api/Datos/SelectAgente',configuracion).then(function(response){            
                agentArray=response.data;
                agentArray.map(function(x){
                    me.agents.push({text:x.nombre,value:x.iddatos});
                });            
            }).catch(function(error){
                console.log(error);
            });            
        },
        listariva(idiva){
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            var rateArray = [];
            var ivaarray;
            var iva;
            
            let configuracion ={headers:header};
            axios.get('api/Ivas/Listariva/'+ idiva,configuracion).then(function(response){            
                ivaarray = response.data;
                ivaarray.map(function(x){
                    iva = x.nombre;
                });
                return iva;
            }).catch(function(error){
                console.log(error);
            });
        },
        Tipocambio(){
            //console.log(this.editedbuysell.idmoneda.value)
            if(this.editedbuysell.idmoneda.value == 1){                        
                this.editedbuysell.idtipocambio = 1;
                this.idtc = 1;
                this.activocobrar = true;
            }else{
                let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
                let header={"Authorization" : "Bearer " + this.$store.state.token};
                var rateArray = [];
                let configuracion ={headers:header};
                axios.get('api/Tipocambios/Listartc/'+ me.editedbuysell.idmoneda.value,configuracion).then(function(response){            
                    rateArray=response.data;
                    me.activocobrar = false;
                    rateArray.map(function(x){
                        me.editedbuysell.idtipocambio = x.tipodecambio;
                        me.idtc = x.idtipocambio;
                    });                                      
                }).catch(function(error){
                    console.log(error);
                });           
            }
        },
        cargarpt(){
            if(this.editedbuysell.idinstance.value == 1){
                this.cargarproveedores();
            }else{
                this.cargarentities(this.editBS.idcustumer);
            }
        },
        cargarproveedores(){
            //console.log('entra p')
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            var providerArray = [];                
            me.provider = [];
            axios.get('api/Datos/SelectProveedor',configuracion).then(function(response){            
                providerArray=response.data;
                providerArray.map(function(x){
                    me.provider.push({text:x.nombre,value:x.iddatos});
                });            
            }).catch(function(error){
                console.log(error);
            });
        },
        cargarentities(id){
        //    console.log('entra entity')
         //   console.log(id)
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            var providerArray = [];                
            me.provider = [];
            axios.get('api/Enlace_Cliente_Proveedor/Select/'+ id,configuracion).then(function(response){            
             //   console.log(providerArray)
                providerArray=response.data;
                providerArray.map(function(x){
                    me.provider.push({text:x.nombre,value:x.idprovedor});
                });            
            }).catch(function(error){
                console.log(error);
            });
        },
        BuscarNumeroCotizacion(){

        },
        BuscarCotizacion(idscotizacion,buscarpor){

            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            var CotInfo = [];
            me.limpiar();
            /*if(buscarpor == 1){
                me.idcotizacion = idscotizacion;
            }else{
                me.idcotizacion = idscotizacion;
            }*/
            
            axios.get('api/Scotizaciones/ListarScotizacionBs/'+ idscotizacion + '/'+ buscarpor ,configuracion).then(function(response){
                CotInfo = response.data;
                //console.log('CotInfo')
                //console.log(CotInfo)
                CotInfo.map(function(x){
                    me.idcotizacion = x.idscotizacion;
                    me.editBS.idbasis = x.idbasis;
                    me.editBS.idcustumer = x.idcustumerogl;
                    if(x.idbasis == 1 || x.idbasis == 2){
                        me.editBS.idmodalidad = 1;
                    }
                    if(x.idbasis == 3 || x.idbasis == 4){
                        me.editBS.idmodalidad = 3;
                    }   
                    if(x.idbasis == 5){
                        me.editBS.idmodalidad = 2;
                    }

                    me.editBS.idbasis = x.idbasis;
                    me.editBS.idtipoOp = x.idtipoOp;

                    if (x.idinland != 0) {
                        me.editBS.indland = 'inland';
                        me.editBS.idinland = x.idinland;
                        me.editBS.dentrodebl = x.dentrodebl;
                        me.indl = true;
                        me.inland = false;
                    }else{
                        me.indl = false;
                        me.inland = true;
                        me.viewinland = true;
                        me.editBS.idinland = 0;
                        me.editBS.dentrodebl = 0;
                    }
                    if(x.customs == true){
                        me.optionsbutton[0] = 'customs';
                    }
                    if(x.insurance == true){                    
                        me.optionsbutton[2] = "insurance";
                    }

                    me.editBS.idportreceipt = x.idportreceipt;
                    me.editBS.idportloading = x.idportloading;
                    me.editBS.idportdischarge = x.idportdischarge;
                    me.editBS.idportdelivery = x.idportdelivery;
                    me.editBS.idusuario = parseInt(me.$store.state.usuario.idusuario);
                    me.editBS.commodity = x.commodity;
                    if(x.hazardous == true){
                        me.editBS.btnhazardous ='hazardous';
                        me.harz=true;
                    }else{
                        me.harz = false;
                    }

                    if(x.idbasis == 1 ||x.idbasis == 3){
                        me.ListarContainers(x.idscotizacion,2);
                    }else{
                        me.ListarPackage(x.idscotizacion);
                    }

                });
                me.activar();
                //console.log(response.data)

            }).catch(function(error){
                console.log(error);
            });

            
            me.mostrarcampos = true;
        },

        editItemBS(item) {
            this.limpiar();
            this.limpiarcharge();
            this.editedIndexbuys = this.BuySellLista.indexOf(item)               
            this.editBS = Object.assign({}, item)

            this.creadopor = item.nombreuscreate + " " + item.fechacreaten; 
            this.editadopor = item.nombreusedit + " " + item.fechaedit;
            this.ncotizacion =  item.ncotizacion;

            if (this.editBS.idinland != 0) {
                this.editBS.indland = 'inland';
                this.indl = true;
                this.inland = false;
                this.viewinland = true;
            }else{
                this.indl = false;
                this.inland = true;
            }
            if(this.editBS.creditDays != 0){
                this.editBS.btcredit ='credit';
                this.credit=true;
            }else{
                this.credit=false;
            }
            if(this.editBS.hazardous != 0){
                this.editBS.btnhazardous ='hazardous';
                this.harz=true;
            }else{
                this.harz=false;
            }
            if(this.editBS.activo == false){
                this.activo = false;
            }
        
            if(this.editBS.customs == true){
                this.optionsbutton[0] = 'customs';
            }
            if(this.editBS.vgm == true){
                this.optionsbutton[1] = 'vgm';
            }
            if(this.editBS.insurance == true){
                this.optionsbutton[2] = 'insurance';
            }
            if(this.editBS.custody == true){
                this.optionsbutton[3] = 'custody';
            }
            if(this.editBS.transfer == true){
                this.optionsbutton[4] = 'transfer';
            }
            if(this.editBS.idportreceipt == 26){
                this.editBS.fechaareceipt = null;
            }
            if(this.editBS.idbasis == 1 || this.editBS.idbasis == 3){
                this.ListarContainers(this.editBS.idbs,1);
            }else{
                this.ListarPackage(this.editBS.idbs);
            }

            this.ListarChargeBS(this.editBS.idbs);           
            this.activar();
            this.mostrarcampos = true;
            
        },
        CargosTotales(item){
         //   console.log( ":" + item + "<br>");
        },
        ListarChargeBS(idbs){
            var buy = [];
            var sell = [];
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            let me=this; 
            axios.get('api/chargesBS/ListarChargesBuy/' + idbs,configuracion).then(function(response){  
                var totalBuy = 0;                          
                me.buysellB = response.data;
                buy = response.data;
                buy.map(function(x){
                    totalBuy = totalBuy + x.total;                    
                });
                    
                me.totalBuy = totalBuy;
                me.idtotalbuy1 = parseFloat(me.totalBuy).toFixed(2);
                me.idtotalbuy = "$ " + me.addCommas(me.idtotalbuy1)


                me.idtotal1 = parseFloat(me.idtotalsell1).toFixed(2) - parseFloat(me.idtotalbuy1).toFixed(2);
                me.idtotal = parseFloat(me.idtotal1).toFixed(2);
                me.idtotal = '$ ' + me.addCommas(me.idtotal)
            }).catch(function(error){
                console.log(error);
            });
            axios.get('api/chargesBS/ListarChargesSell/' + idbs,configuracion).then(function(response){                            
                me.buysells=response.data;
                sell = response.data;
                var totalsell = 0;
                sell.map(function(x){
                    totalsell = totalsell + x.total
                })
                me.totalSell = totalsell;
                me.idtotalsell1 = parseFloat(me.totalSell).toFixed(2);
                me.idtotalsell = '$ ' + me.addCommas(me.idtotalsell1)

                me.idtotal1 = parseFloat(me.idtotalsell1).toFixed(2) - parseFloat(me.idtotalbuy1).toFixed(2);
                me.idtotal = parseFloat(me.idtotal1).toFixed(2);
                me.idtotal = '$ ' + me.addCommas(me.idtotal)
            }).catch(function(error){
                console.log(error);
            });
        },
        ListarContainers(idbs,categoria){
            var datoscontainer = [];
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            let me=this;
            me.containers = [];
            axios.get('api/DatosContainerUnits/ListarContainersbs/' + idbs + '/' + categoria,configuracion).then(function(response){                            
                datoscontainer=response.data;
                datoscontainer.map(function(x){
                    me.containers.push({
                        idcontainer:x.idcontainer,
                        quantity:x.quantity,
                        size:x.size,
                        idsize:x.idsize,
                        type:x.type,
                        idtype:x.idtype,
                        weight:x.weight,
                        nweight:me.addCommas(parseFloat(x.nweight).toFixed(2)),
                        remarks:'',
                        idunidadmasa:x.idunidadmasa,
                        weightsnconv:x.weightsnconv,
                        activo:true
                    })
                })
            }).catch(function(error){
            console.log(error);
            });
        },
        ListarPackage(idbs){
            var datospackage = [];
            this.addpackages = [];
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            let me=this;
            axios.get('api/Packages/ListarPackage/' + idbs,configuracion).then(function(response){                            
                datospackage=response.data;
                datospackage.map(function(x){
                    var pwidth = 0;
                    var plarge = 0;
                    var phigh = 0;
                    var pesovolumetrico = 0;
                    var pesovolcompleto = 0;

                    if(me.editBS.idbasi == 5){
                        pwidth = x.width * 100;
                        plarge = x.large * 100;
                        phigh = x.high * 100;
                        pesovolumetrico = ((pwidth * plarge) * phigh) / 6000;
                        pesovolumetrico = pesovolumetrico * x.quantity;
                        pesovolcompleto = parseFloat(pesovolumetrico).toFixed(2) + ' Kg.';
                    }else{
                        pwidth = x.width;
                        plarge = x.large;
                        phigh = x.high;
                        pesovolumetrico = ((pwidth * plarge) * phigh);
                        pesovolumetrico = pesovolumetrico * x.quantity;
                        pesovolcompleto = parseFloat(pesovolumetrico).toFixed(2) + ' Ton.';
                    }
                    
                    var nstackable;
                    var actualweight = x.quantity * x.weight;

                    if(x.stackable == true){
                        nstackable = 'yes'
                    }else{
                        nstackable = 'no'
                    }
                    me.addpackages.push({
                        idspackage:x.idspackage,
                        longitud:'',
                        idlongitud:x.idlongitud,
                        idpeso:x.idpeso,
                        stackable:x.stackable,
                        nstackable:nstackable,
                        weight:x.weight,
                        nweight:parseFloat(x.weight).toFixed(2) + ' Kg.',
                        high:x.high,
                        width:x.width,
                        large:x.large,
                        nhigh:x.high + ' Mts.',
                        nwidth:x.width + ' Mts.',
                        nlarge:x.large + ' Mts.',
                        volumetricweight:pesovolcompleto,
                        actualweight:parseFloat(actualweight).toFixed(2) + ' Kg.',
                        idpackage:x.idpackage,
                        quantity:x.quantity,
                        package:x.tnpackage,
                        Notes:x.notes,
                        otropackage:x.otropackage,
                        activo:x.activo,
                    })
                })
            }).catch(function(error){
            console.log(error);
            });
        },
        guardar() {
    let model = this;

    // 1. PROTECCIÓN ANTI-DOBLE CLIC: Si ya está procesando, cancelamos el segundo clic.
    if (model.dialodload) {
        return; 
    }

            let header = { "Authorization": "Bearer " + this.$store.state.token };
            let configuracion = { headers: header };
            var i;
            var customs = 0;
            var vgm = 0;
            var insurance = 0;
            var custody = 0;
            var transfer1 = 0;

            if (model.editBS.idbasis == 3 || model.editBS.idbasis == 4) {
                model.limpiarmaritimo();
            } else {
                if (model.indl == false) {
                    model.limpiarterrestre();
                }
            }

            if (model.validar()) {
                return;
            }

            // 2. ACTIVAMOS LA PANTALLA DE CARGA / BLOQUEO
            model.dialodload = true;

            for (i = 0; i < model.optionsbutton.length; i++) {
                if (model.optionsbutton[i] == 'customs') { customs = 1; }
                if (model.optionsbutton[i] == 'vgm') { vgm = 1; }
                if (model.optionsbutton[i] == 'insurance') { insurance = 1; }
                if (model.optionsbutton[i] == 'custody') { custody = 1; }
                if (model.optionsbutton[i] == 'transfer') { transfer1 = 1; }
            }

            if (model.editBS.btnhazardous == 'hazardous') {
                model.hazar = 1;
            } else {
                model.hazar = 0;
            }

            var f = new Date();
            var hoy = f.getDate() + "/0" + (f.getMonth() + 1) + "/" + f.getFullYear();
            var qua;

            if (model.editBS.idbasis == 3 || model.editBS.idbasis == 4) {
                model.editBS.fechaeta = "01/01/1753";
                model.editBS.fechaetd = "01/01/1753";
            }
            if (model.editBS.idportdelivery == 0) {
                model.editBS.idportdelivery = 26;
            }
            if (model.editBS.idportreceipt == 0 || model.editBS.idportreceipt == 26) {
                model.editBS.fechaareceipt = "01/01/1753";
                model.editBS.idportreceipt = 26;
            }
            if (model.editBS.idbasis == 1 && model.indl == false || model.editBS.idbasis == 2 && model.indl == false || model.editBS.idbasis == 5 && model.indl == false) {
                model.editBS.fechadelivery = "01/01/1753";
            }
            if (model.editBS.idbasis == 1 && model.indl == true || model.editBS.idbasis == 2 || model.editBS.idbasis == 5 && model.indl == true) {
                model.editBS.fechadelivery = "01/01/1753";
            }
            if (model.editBS.freedaysoriginB == '') {
                model.editBS.freedaysoriginB = 0;
            }
            if (model.editBS.freedaysoriginS == '') {
                model.editBS.freedaysoriginS = 0;
            }
            if (model.editBS.freedaysdestB == '') {
                model.editBS.freedaysdestB = 0;
            }
            if (model.editBS.freedaysdestS == '') {
                model.editBS.freedaysdestS = 0;
            }
            if (model.editBS.creditDays == '') {
                model.editBS.creditDays = 0;
            }
            if (model.editBS.idvessel == 0) {
                model.editBS.idvessel = 7;
            }

            if (model.editBS.indland != 'inland') {
                model.editBS.dentrodebl = 0;
                model.editBS.idinland = 0;
            }

            if (model.containers.length <= 0 && model.addpackages.length <= 0) {
                window.alert('Ingresa almenos un dato en unidad/contenedor o paquete');
                model.dialodload = false; // Desbloqueamos si falta info
                return; // Detenemos la ejecución aquí
            } else {
                if (model.editedIndexbuys > -1) {
                    // --- CÓDIGO PARA EDITAR (PUT) ---
                    axios.put('api/Buysells/Actualizar', {
                        'idbs': model.editBS.idbs,
                        'numbs': model.editBS.nbuysell,
                        'idusuario': model.editBS.idusuario,
                        'iduseedt': model.$store.state.usuario.idusuario,
                        'idmodalidad': model.editBS.idmodalidad,
                        'idbasis': model.editBS.idbasis,
                        'idtipoOp': model.editBS.idtipoOp,
                        'idinland': model.editBS.idinland,
                        'customs': customs,
                        'transfer': transfer1,
                        'vgm': vgm,
                        'insurance': insurance,
                        'custody': custody,
                        'idcustumer': model.editBS.idcustumer,
                        'creditDays': model.editBS.creditDays,
                        'comodity': model.editBS.commodity,
                        'fahscode': model.editBS.fahscode,
                        'hazardous': model.hazar,
                        'class1': model.editBS.class1,
                        'un': model.editBS.un,
                        'idprovider': model.editBS.idprovider,
                        'qt': model.editBS.qt,
                        'idportreceipt': model.editBS.idportreceipt,
                        'idportloading': model.editBS.idportloading,
                        'idportdischarge': model.editBS.idportdischarge,
                        'idportdelivery': model.editBS.idportdelivery,
                        'idvessel': model.editBS.idvessel,
                        'voyage': model.editBS.voyage,
                        'fechaeta': model.editBS.fechaeta,
                        'fechaetd': model.editBS.fechaetd,
                        'fechaareceipt': model.editBS.fechaareceipt,
                        'fechadelivery': model.editBS.fechadelivery,
                        'remarks': model.editBS.remarks,
                        'reference': model.editBS.reference,
                        'freedaysoriginB': model.editBS.freedaysoriginB,
                        'freedaysoriginS': model.editBS.freedaysoriginS,
                        'freedaysdestB': model.editBS.freedaysdestB,
                        'freedaysdestS': model.editBS.freedaysdestS,
                        'idagent': model.editBS.idagent,
                        'dentrodebl': model.editBS.dentrodebl,
                        'chargebssell': model.buysells,
                        'chargebsbuy': model.buysellB,
                        'Container': model.containers,
                        'Spackages': model.addpackages,
                    }, configuracion).then(function (response) {
                        model.colorm = 'info';
                        model.snackbar = true;
                        model.mensaje = model.editBS.nbuysell + ' actualizada correctamente';
                        model.limpiar();
                        model.listar();
                        model.mostrarcampos = false;
                    }).catch(function (error) {
                        console.log(error);
                        model.colorm = 'error';
                        model.snackbar = true;
                        // Leemos el error real del backend, si no existe, mostramos el genérico
                        let errorMsg = error.response && error.response.data ? error.response.data : error;
                        model.mensaje = 'Error al actualizar la Bs: ' + errorMsg;
                    }).finally(function () {
                        // 3. DESBLOQUEAMOS LA PANTALLA DE CARGA (Ocurra error o éxito)
                        model.dialodload = false;
                    });
                } else {
                    // --- CÓDIGO PARA GUARDAR NUEVO (POST) ---
                    axios.post('api/Buysells/Crear', {
                        'idusuario': model.editBS.idusuario,
                        'idusecreate': model.$store.state.usuario.idusuario,
                        'idmodalidad': model.editBS.idmodalidad,
                        'idbasis': model.editBS.idbasis,
                        'idtipoOp': model.editBS.idtipoOp,
                        'idinland': model.editBS.idinland,
                        'customs': customs,
                        'transfer': transfer1,
                        'vgm': vgm,
                        'insurance': insurance,
                        'custody': custody,
                        'idcustumer': model.editBS.idcustumer,
                        'creditDays': model.editBS.creditDays,
                        'comodity': model.editBS.commodity,
                        'fahscode': model.editBS.fahscode,
                        'hazardous': model.hazar,
                        'class1': model.editBS.class1,
                        'un': model.editBS.un,
                        'idprovider': model.editBS.idprovider,
                        'qt': model.editBS.qt,
                        'idportreceipt': model.editBS.idportreceipt,
                        'idportloading': model.editBS.idportloading,
                        'idportdischarge': model.editBS.idportdischarge,
                        'idportdelivery': model.editBS.idportdelivery,
                        'idvessel': model.editBS.idvessel,
                        'voyage': model.editBS.voyage,
                        'fechaeta': model.editBS.fechaeta,
                        'fechaetd': model.editBS.fechaetd,
                        'fechaareceipt': model.editBS.fechaareceipt,
                        'fechadelivery': model.editBS.fechadelivery,
                        'remarks': model.editBS.remarks,
                        'reference': model.editBS.reference,
                        'freedaysoriginB': model.editBS.freedaysoriginB,
                        'freedaysoriginS': model.editBS.freedaysoriginS,
                        'freedaysdestB': model.editBS.freedaysdestB,
                        'freedaysdestS': model.editBS.freedaysdestS,
                        'idagent': model.editBS.idagent,
                        'dentrodebl': model.editBS.dentrodebl,
                        'chargebssell': model.buysells,
                        'chargebsbuy': model.buysellB,
                        'Container': model.containers,
                        'Spackages': model.addpackages,
                        'idcotizacion': model.idcotizacion,
                        'ncotizacion': model.ncotizacion,
                    }, configuracion).then(function (response) {
                        model.colorm = 'info';
                        model.snackbar = true;
                        model.mensaje = 'BS guardada correctamente N° ' + response.data;
                        model.limpiar();
                        model.listar();
                        model.mostrarcampos = false;
                    }).catch(function (error) {
                        console.log(error);
                        model.colorm = 'error';
                        model.snackbar = true;
                        // Leemos el error real del backend, si no existe, mostramos el genérico
                        let errorMsg = error.response && error.response.data ? error.response.data : error;
                        model.mensaje = 'Error al guardar Bs: ' + errorMsg;
                    }).finally(function () {
                        // 3. DESBLOQUEAMOS LA PANTALLA DE CARGA (Ocurra error o éxito)
                        model.dialodload = false;
                    });
                }
            }
        },
        validar(){
            this.valida=0;
            this.validaMensaje=[];
            var selecciona = 'Please select ';
            var entra = false;

            if(!this.editBS.idbasis){
                selecciona = "Basis,";
                entra = true;
            }
            if(!this.editBS.idtipoOp){
                selecciona = selecciona + " Operation Type,";
                entra = true;
            }
            if(!this.editBS.idusuario){
               selecciona = selecciona + " Sales Executive,";  
                entra = true;
            }
            if(!this.editBS.idcustumer || this.editBS.idcustumer == 71){
                selecciona = selecciona + " Customer Name,";
                entra = true;
            }
            
            if(this.editBS.idbasis == 3 || this.editBS.idbasis == 4){
                if(!this.editBS.idprovider || this.editBS.idprovider == 71){
                    selecciona = selecciona + " Provider,";
                    entra = true;
                }
                if(!this.editBS.idportreceipt || this.editBS.idportreceipt == 26){
                    selecciona = selecciona + " Port of Pickup,";
                    entra = true;
                }
                if(!this.editBS.idportdelivery || this.editBS.idportdelivery == 26){
                    selecciona = selecciona + " Port of Delivery,";
                    entra = true;
                }
                if(this.editBS.fechaareceipt == '' || this.editBS.fechaareceipt == null){
                    selecciona = selecciona + " Date of Pickup,";
                    entra = true;
                }
                if(this.editBS.fechadelivery == '' || this.editBS.fechadelivery == null){
                    selecciona = selecciona + " Date of Delivery,";
                    entra = true;
                }
            }else{
                if(this.editBS.idbasis != 5){
                    if(this.editBS.freedaysdestS <= 0 || this.editBS.freedaysdestS == "" || this.editBS.freedaysdestB <= 0 || this.editBS.freedaysdestB == "0" 
                        || this.editBS.freedaysoriginS <= 0|| this.editBS.freedaysoriginS == "" || this.editBS.freedaysoriginB <= 0 || this.editBS.freedaysoriginB == ""){
                        selecciona = selecciona + "Free days,";  
                        entra = true;
                    }
                }
                if(!this.editBS.idprovider || this.editBS.idprovider == 71){
                    selecciona = selecciona + " shipping Line,";
                    entra = true;
                }                if(!this.editBS.idportloading || this.editBS.idportloading == 26){
                    selecciona = selecciona + " Port of loading,";
                    entra = true;
                }
                if(!this.editBS.idportdischarge || this.editBS.idportdischarge == 26){
                    selecciona = selecciona + " Port of discharge,";
                    entra = true;
                }
                if(this.indl){
                    if(!this.editBS.idinland){
                        selecciona = selecciona + " Inland,";
                        entra = true;
                    }
                    if(!this.editBS.dentrodebl){
                        selecciona = selecciona + " Dentro/Fuera BL,";
                        entra = true;
                    }
                    if(!this.editBS.idportreceipt && !this.editBS.idportdelivery || this.editBS.idportreceipt == 26 && this.editBS.idportdelivery == 26){
                        selecciona = selecciona + "Port of Receipt or Discharge,";
                        entra = true;
                    }
                    if(this.editBS.idportreceipt != 26 && this.editBS.fechaareceipt == '' || this.editBS.idportreceipt != 26 && this.editBS.fechaareceipt == null){
                        selecciona = selecciona + "date of pick up,";
                        entra = true;
                    }
                }
                if(!this.editBS.fechaeta){
                    selecciona = selecciona + " eta,";
                    entra = true;
                }
                if(!this.editBS.fechaetd){
                   selecciona = selecciona + " etd,";
                    entra = true;
                }    
            }
            if(!this.editBS.idagent || this.editBS.idagent == 71){
                selecciona = selecciona + " Forwarder Agent,";
                entra = true;
            }
            if(entra == true){
                this.valida=1;
                window.alert(selecciona)
            }
             
             return this.valida;
        },
        limpiarmaritimo(){
            this.editBS.idinland = 0;
            this.editBS.indland = [];
            this.editBS.idportloading = 26;
            this.editBS.idportdischarge = 26;
            this.editBS.fechaeta = null;
            this.editBS.fechaetd = null;
            this.editBS.dentrodebl = '';
            this.indl = false;
            this.inland = true;
        },
        limpiarterrestre(){
            this.editBS.idportreceipt = 26;
            this.editBS.datereceipt = null;
             this.editBS.fechaareceipt = null;
            this.editBS.idportdelivery = 26;
            this.editBS.datedeliviry = null;
            this.editBS.dentrodebl = '';
            this.editBS.idinland = 0;
            this.editBS.indland = [];
        },
        Cancelar(){
            let model=this;
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};

            var resp = confirm('Are you sure you want to delete this BS?');
            if(resp == true){    
                axios.put('api/Buysells/Desactivar/'+model.editBS.idbs,{},configuracion).then(function(response){
                    model.colorm ='error'
                    model.snackbar = true            
                    model.mensaje = 'Bs cancelada correctamente';
                    model.limpiar();
                    model.mostrarcampos = false;
                }).catch(function(error){
                    console.log(error);
                });
            }
        },
        async limpiar(){
            this.editBS.idusuario = 0;
            this.editBS.idmodalidad = 0;
            this.editBS.idbasis = 0;
            this.editBS.idtipoOp = 0;
            this.editBS.idinland = 0;
            this.optionsbutton = [];
            this.editBS.class1 = '';
            this.editBS.un = '';
            this.editBS.idcustumer = 71;
            this.editBS.btcredit = [];
            this.editBS.creditDays = 0;
            this.editBS.commodity = '';
            this.editBS.fahscode = '';
            this.editBS.btnhazardous = [];
            this.editBS.hazardous = '';
            this.editBS.indland = [];
            this.editBS.idprovider = 71;
            this.editBS.qt = '';
            this.editBS.idportreceipt = 26;
            this.editBS.datereceipt = null;
            this.editBS.idportloading = 26;
            this.editBS.idportdischarge = 26;
            this.editBS.idportdelivery = 26;
            this.editBS.datedeliviry = null;
            this.editBS.freedaysoriginB = 0;
            this.editBS.freedaysoriginS = 0;
            this.editBS.idvessel = 7;
            this.editBS.voyage = '';
            this.editBS.freedaysdestB = 0;
            this.editBS.freedaysdestS = 0;
            this.editBS.fechaeta = '';
            this.editBS.fechaetd = '';
            this.editBS.remarks = '',
            this.editBS.idagent = 71;
            this.editBS.fechaareceipt = '';
            this.editBS.fechadelivery = '';
            this.editBS.nbuysell = '';
            this.totalSell = '';
            this.totalBuy = '';
            this.total = '';
            this.totalmxn = '';
            this.buysells = [];
            this.buysellB = [];
            this.containers = [];
            this.editedbuysell.idtamano = '';
            this.editedbuysell.idcontenedor = '';
            this.addpackages = [];
            this.editBS.dentrodebl = '';
            this.editedIndexbuys = -1;
            this.totalBuy = '';
            this.idtotal = '';
            this.idtotal1 = '';
            this.idtotalbuy1 = '';
            this.idtotalbuy = '';
            this.totalSell = '';
            this.idtotalsell1 = '';
            this.idtotalsell = '';
            this.editBS.reference = '';
            this.cobrarpesos = false;
            this.indl = false;
            this.inland = true;
            this.activo = true;
            this.CONTAINER = false;
            this.PACKAGES = false;
        },
        Credityes(){
            if(this.credit == true){
                this.credit=false;
            }
            else{
                this.credit=true;
            }
        },
        mostrarhazardous(){
            if(this.harz == true){
                this.harz=false;
            }
            else{
                this.harz=true;
            }
        },
        mostrarinland(){
            if(this.indl == true){
                this.indl = false;
                this.inland = true;
            }
            else{
                this.indl = true;
                this.inland = false;
            }            
        },
        formatDate(date){
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },
        validarpackage(){

            this.valida=0;
            this.validaMensaje=[];
            var selecciona = 'Please select ';
            var entra = false;

            if(this.editpackage.quantity <= 0){
                selecciona = "Quantity, ";
                entra = true;
            }
            if(this.editpackage.idpackage.value == undefined || this.editpackage.idpackage.value <= 0) {
                if(this.editedIndexpack == -1){
                    selecciona = selecciona + "Package, ";
                    entra = true;
                }
            }
            if(this.editpackage.weight <= 0){
                selecciona = selecciona + "Weight, ";
                entra = true;
            }
            if(this.editpackage.large <= 0){
                selecciona = selecciona + "Large, ";
                entra = true;
            }
            if(this.editpackage.width <= 0){
                selecciona = selecciona + "Width, ";
                entra = true;
            }
            if(this.editpackage.high <= 0){
                selecciona = selecciona + "Heigh, ";
                entra = true;
            }

            if(entra == true){
                this.valida=1;
                window.alert(selecciona)
            }
             
             return this.valida;
        },
        agregarpackage(){
            
            if(this.validarpackage()){
                return;
            }
            if(this.editpackage.idpackage.value <=0 || this.editpackage.weight <= 0){
                window.alert('Agregar cantidad de paquetes, tipo de paquete, Peso de paquete')
            }else{
                    var packagetext;
                    var stackable;
                    var indexmasa;
                    var indexlongitud;
                    var peso;
                    var longitud;

                    if(this.editpackage.peso.value == undefined){
                        indexmasa = this.Masa.findIndex(x=>x.value == this.editpackage.peso);
                        peso = this.editpackage.peso;
                    }else{
                        indexmasa = this.Masa.findIndex(x=>x.value == this.editpackage.peso.value);
                        peso = this.editpackage.peso.value;
                    }
                    var idmasa = this.Masa[indexmasa].idclave;


                    if(this.editpackage.longitud.value == undefined){
                        indexlongitud = this.Longitud.findIndex(x=>x.value == this.editpackage.longitud);
                        longitud = this.editpackage.longitud;
                    }else{
                        indexlongitud = this.Longitud.findIndex(x=>x.value == this.editpackage.longitud.value);
                        longitud = this.editpackage.longitud.value;
                    }
                    var idlongitud = this.Longitud[indexlongitud].idclave;


                    if(this.editpackage.idpackage.value == undefined){
                        if(this.editpackage.idpackage == 1002){
                            packagetext = this.editpackage.otropackage;
                        }else{
                            packagetext = this.editpackage.package;
                        }
                    }else{
                        if(this.editpackage.idpackage.value == 1002){
                            packagetext = this.editpackage.otro;
                        }else{
                            packagetext = `${this.editpackage.idpackage.text}`;
                        }
                    }
                    
                    if(this.editpackage.stackable == 'yes'){
                        stackable = 1;
                    }else{
                        stackable = 0;
                    }

                    var longitud;
                    var nlongitud;
                    var masa;
                    var nmasa;
                    var weight;
                    var large;
                    var high;
                    var width;

                    if(idlongitud == 'MT1'){
                        large = this.editpackage.large;
                        width = this.editpackage.width;
                        high = this.editpackage.high;
                    }
                     if(idlongitud == 'CM1' ){ //Centimetros a Metros
                        large = parseFloat(this.editpackage.large / 100).toFixed(2);
                        width = parseFloat(this.editpackage.width / 100).toFixed(2);
                        high = parseFloat(this.editpackage.high / 100).toFixed(2);
                    }
                    if(idlongitud == 'PI1'){ //Pies a Metros
                        large = parseFloat(this.editpackage.large / 3.28084).toFixed(2);
                        width = parseFloat(this.editpackage.width / 3.28084).toFixed(2);
                        high = parseFloat(this.editpackage.high / 3.28084).toFixed(2);
                    }
                    if(idlongitud == 'PU1'){ //Pies a Metros
                        large = parseFloat(this.editpackage.large / 39.3701).toFixed(2);
                        width = parseFloat(this.editpackage.width / 39.3701).toFixed(2);
                        high = parseFloat(this.editpackage.high / 39.3701).toFixed(2);
                    }
                  /* if(this.editpackage.longitud.value == undefined){
                        if(this.editpackage.longitud == 1){
                            large = this.editpackage.large;
                            width = this.editpackage.width;
                            high = this.editpackage.high;
                        }
                    }else{
                        if(this.editpackage.longitud.value == 1){
                            large = this.editpackage.large;
                            width = this.editpackage.width;
                            high = this.editpackage.high;
                        }
                    }*/
                   /* if(this.editpackage.peso.value == undefined){
                        if(this.editpackage.peso == 1){
                            weight = this.editpackage.weight
                        }
                    }else{
                        if(this.editpackage.peso.value == 1){
                            weight = this.editpackage.weight
                        }
                    }*/
                    
                    /*if(this.editpackage.longitud.value == undefined){
                        if(this.editpackage.longitud == 4 ){ //Centimetros a Metros
                            large = parseFloat(this.editpackage.large / 100).toFixed(2);
                            width = parseFloat(this.editpackage.width / 100).toFixed(2);
                            high = parseFloat(this.editpackage.high / 100).toFixed(2);
                        }
                    }else{
                        if(this.editpackage.longitud.value == 4 ){ //Centimetros a Metros
                            large = parseFloat(this.editpackage.large / 100).toFixed(2);
                            width = parseFloat(this.editpackage.width / 100).toFixed(2);
                            high = parseFloat(this.editpackage.high / 100).toFixed(2);
                        }   
                    }*/
                    
                   /* if(this.editpackage.longitud.value == undefined){
                        if(this.editpackage.longitud == 2){ //Pies a Metros
                            large = parseFloat(this.editpackage.large / 3.28084).toFixed(2);
                            width = parseFloat(this.editpackage.width / 3.28084).toFixed(2);
                            high = parseFloat(this.editpackage.high / 3.28084).toFixed(2);
                        }
                    }else{
                        if(this.editpackage.longitud.value == 2){ //Pies a Metros
                            large = parseFloat(this.editpackage.large / 3.28084).toFixed(2);
                            width = parseFloat(this.editpackage.width / 3.28084).toFixed(2);
                            high = parseFloat(this.editpackage.high / 3.28084).toFixed(2);
                        }
                    }*/

                    /*if(this.editpackage.longitud.value == undefined){
                        if(this.editpackage.longitud == 3){ //Pies a Metros
                            large = parseFloat(this.editpackage.large / 39.3701).toFixed(2);
                            width = parseFloat(this.editpackage.width / 39.3701).toFixed(2);
                            high = parseFloat(this.editpackage.high / 39.3701).toFixed(2);
                        }
                    }else{
                        if(this.editpackage.longitud.value == 3){ //Pies a Metros
                            large = parseFloat(this.editpackage.large / 39.3701).toFixed(2);
                            width = parseFloat(this.editpackage.width / 39.3701).toFixed(2);
                            high = parseFloat(this.editpackage.high / 39.3701).toFixed(2);
                        }
                    }*/
                    
                    /*if(this.editpackage.peso.value == undefined){
                        if(this.editpackage.peso == 2){//Toneladas a Kilogramos
                            weight = parseFloat(this.editpackage.weight * 1000).toFixed(2); 
                        }
                    }else{
                        if(this.editpackage.peso.value == 2){//Toneladas a Kilogramos
                            weight = parseFloat(this.editpackage.weight * 1000).toFixed(2); 
                        }
                    }*/
                    if(idmasa == 'KL1'){//Toneladas a Kilogramos
                        weight = parseFloat(this.editpackage.weight).toFixed(2); 
                    }
                    if(idmasa == 'TN1'){//Toneladas a Kilogramos
                        weight = parseFloat(this.editpackage.weight * 1000).toFixed(2); 
                    }
                    if(idmasa == 'GR1'){//Gramos a Kilogramos
                        weight = parseFloat(this.editpackage.weight / 1000).toFixed(2); 
                    }
                    if(idmasa == 'LI1'){//Libras a Kilogramos
                        weight = parseFloat(this.editpackage.weight * 0.453592).toFixed(2); 
                    }
                    
                    /*if(this.editpackage.peso.value == undefined){
                        if(this.editpackage.peso == 3){//Libras a Kilogramos
                            weight = parseFloat(this.editpackage.weight * 0.453592).toFixed(2); 
                        }
                    }else{
                        if(this.editpackage.peso.value == 3){//Libras a Kilogramos
                            weight = parseFloat(this.editpackage.weight * 0.453592).toFixed(2); 
                        }
                    }*/
                    /*if(this.editpackage.peso.value == undefined){
                        if(this.editpackage.peso == 5){//Libras a Kilogramos
                            weight = parseFloat(this.editpackage.weight * 0.453592).toFixed(2); 
                        }
                    }else{
                        if(this.editpackage.peso.value == 5){//Libras a Kilogramos
                            weight = parseFloat(this.editpackage.weight * 0.453592).toFixed(2); 
                        }
                    }*/
                    
                    
                    var pwidth = width;
                    var plarge = large;
                    var phigh = high;
                    var pesovolumetrico;
                    var pesovolcompleto;

                    if(this.editBS.idbasis == 5){
                        pwidth = width * 100;
                        plarge = large * 100;
                        phigh = high * 100;

                        pesovolumetrico = ((pwidth * plarge) * phigh) / 6000;
                        pesovolumetrico = pesovolumetrico * this.editpackage.quantity;
                        pesovolcompleto = parseFloat(pesovolumetrico).toFixed(2) + ' Kg.';

                    }else{
                        pwidth = width;
                        plarge = large;
                        phigh = high;

                        pesovolumetrico = ((pwidth * plarge) * phigh);
                        pesovolumetrico = pesovolumetrico * this.editpackage.quantity;
                        pesovolcompleto = parseFloat(pesovolumetrico).toFixed(2) + ' Ton.';
                    }
                    var actualweight = this.editpackage.quantity * weight;

                if (this.editedIndexpack > -1) {
                    //var idlongitud;
                    //var peso;
                    var idpackage;
                   /* if(this.editpackage.longitud.value == undefined){
                        idlongitud =this.editpackage.longitud;
                    }else{
                        idlongitud =this.editpackage.longitud.value;
                    }
                    if(this.editpackage.peso.value == undefined){
                        peso = this.editpackage.peso;
                    }else{
                        peso = this.editpackage.peso.value;
                    }*/
                    if(this.editpackage.idpackage.value == undefined){
                        idpackage = this.editpackage.idpackage;
                    }else{
                        idpackage = this.editpackage.idpackage.value;
                    }
                    Object.assign(this.addpackages[this.editedIndexpack],{
                        idspackage:this.editpackage.idspackage,
                        longitud: longitud,
                        idlongitud:longitud,
                        idpeso:peso,
                        stackable:stackable,
                        nstackable:this.editpackage.stackable,
                        weight:weight,
                        nweight:this.addCommas(parseFloat(weight).toFixed(2)) + ' Kg.',
                        high:high,
                        width:width,
                        large:large,
                        nhigh:high + ' Mts.',
                        nwidth:width + ' Mts.',
                        nlarge:large + ' Mts.',
                        volumetricweight:pesovolcompleto,
                        actualweight:this.addCommas(parseFloat(actualweight).toFixed(2)) + ' Kg.',
                        idpackage:idpackage,
                        quantity:this.editpackage.quantity,
                        package:packagetext,
                        Notes:this.editpackage.Notes,
                        otropackage:this.editpackage.otropackage,
                        activo:true,
                    })
                } else {
                    this.addpackages.push({
                            idspackage:0,
                            longitud: `${this.editpackage.longitud.text}`,
                            idlongitud:this.editpackage.longitud.value,
                            idpeso:this.editpackage.peso.value,
                            stackable:stackable,
                            nstackable:this.editpackage.stackable,
                            weight:weight,
                            nweight:this.addCommas(parseFloat(weight).toFixed(2)) + ' Kg.',
                            high:high,
                            width:width,
                            large:large,
                            nhigh:high + ' Mts.',
                            nwidth:width + ' Mts.',
                            nlarge:large + ' Mts.',
                            volumetricweight:pesovolcompleto,
                            actualweight:this.addCommas(parseFloat(actualweight).toFixed(2)) + ' Kg.',
                            idpackage:this.editpackage.idpackage.value,
                            quantity:this.editpackage.quantity,
                            package:packagetext,
                            Notes:this.editpackage.Notes,
                            otropackage:this.editpackage.otropackage,
                            activo:true,
                        })
                    }
                    this.limpiarpackage();
            }
        },
        limpiarpackage(){
            this.editpackage.longitud = {text:'Metro',value:1};
            this.editpackage.peso = {text:'Kilo',value:1};
            this.editpackage.stackable = '';
            this.editpackage.large = '';
            this.editpackage.width = '';
            this.editpackage.high = '';
            this.editpackage.weight  = '';
            this.editpackage.idpackage = '';
            this.editpackage.quantity = '';
            this.editpackage.Notes = '';
            this.editedIndexpack = -1;
        },
        agregar(){
           if(this.editcontainer.quantity  <= 0 || this.editcontainer.size.value <= 0 || this.editcontainer.type.value   <= 0 || this.editcontainer.weight <= 0){
                alert("Favor de llenar todos los campos ");
            }else{
                var weight = 0;
                var indexmasa = 0;
                var peso = 0;

                if(this.editcontainer.peso.value == undefined){
                    indexmasa = this.Masa.findIndex(x=>x.value == this.editcontainer.peso );
                    peso = this.editcontainer.peso;
                }else{
                    indexmasa = this.Masa.findIndex(x=>x.value == this.editcontainer.peso.value );
                    peso = this.editcontainer.peso.value;
                }

                var idmasa = this.Masa[indexmasa].idclave;

                if(idmasa == 'KL1'){//Toneladas a Kilogramos
                    weight = parseFloat(this.editcontainer.weight).toFixed(2); 
                }
                if(idmasa == 'TN1'){//Toneladas a Kilogramos
                    weight = parseFloat(this.editcontainer.weight * 1000).toFixed(2); 
                }
                if(idmasa == 'GR1'){//Gramos a Kilogramos
                    weight = parseFloat(this.editcontainer.weight / 1000).toFixed(2); 
                }
                if(idmasa == 'LI1'){//Libras a Kilogramos
                    weight = parseFloat(this.editcontainer.weight * 0.453592).toFixed(2); 
                }

               if (this.editedIndexc > -1) {
                  var idsize;
                  var size;
                  var idtype;
                  var type;
                  
                  if(this.editcontainer.idsize.value == undefined){
                      idsize = this.editcontainer.idsize;
                      size = this.editcontainer.size;
                  }else{
                      idsize = this.editcontainer.idsize.value;
                      size = `${this.editcontainer.idsize.text}`;
                  }
                  if(this.editcontainer.idtype.value == undefined){
                      idtype = this.editcontainer.idtype;
                      type = this.editcontainer.type;
                  }else{
                      idtype = this.editcontainer.idtype.value;
                      type = `${this.editcontainer.idtype.text}`;
                  }
                   Object.assign(this.containers[this.editedIndexc],{
                        quantity:this.editcontainer.quantity,
                        size:size,
                        idsize:idsize,
                        type:type,
                        idtype:idtype,
                        weight:weight,
                        nweight:this.addCommas(weight) +' Kg',
                        remarks:'',
                        idunidadmasa:peso,
                        weightsnconv:this.editcontainer.weight,
                        activo:true
                   })
                   this.limpiarcontenedor();
                } else {
                  this.containers.push({
                        quantity:this.editcontainer.quantity,
                        size:`${this.editcontainer.idsize.text}`,
                        idsize:this.editcontainer.idsize.value,
                        type:`${this.editcontainer.idtype.text}`,
                        idtype:this.editcontainer.idtype.value,
                        weight:weight,
                        nweight:this.addCommas(weight) +' Kg',
                        remarks:'',
                        idunidadmasa:peso,
                        weightsnconv:this.editcontainer.weight,
                        activo:true
                    })
                    this.limpiarcontenedor();
                }
           }
        },
        editItempackage(item){
            this.editedIndexpack = this.addpackages.indexOf(item)
            if(item.stackable == true){
                this.editpackage.stackable = 'yes';
            }
            var large;
            var width;
            var high;

            var indexlongitud = this.Longitud.findIndex(x=>x.value == item.idlongitud);
            var idlongitud = this.Longitud[indexlongitud].idclave;
            
            if(idlongitud == 'MT1'){
                large = parseFloat(item.large).toFixed(2);
                width = parseFloat(item.width).toFixed(2);
                high = parseFloat(item.high).toFixed(2); 
            }           
            if(idlongitud == 'PI1'){ //Pies a Metros
                large = parseFloat(item.large * 3.28084).toFixed(2);
                width = parseFloat(item.width * 3.28084).toFixed(2);
                high = parseFloat(item.high * 3.28084).toFixed(2);
            }
            if(idlongitud == 'PU1'){ //Pies a Metros
                large = parseFloat(item.large * 39.3701).toFixed(2);
                width = parseFloat(item.width * 39.3701).toFixed(2);
                high = parseFloat(item.high * 39.3701).toFixed(2);
            }
            if(idlongitud == 'CM1' ){ //Centimetros a Metros
                large = parseFloat(item.large * 100).toFixed(2);
                width = parseFloat(item.width * 100).toFixed(2);
                high = parseFloat(item.high * 100).toFixed(2);
            }
            
            var indexmasa = this.Masa.findIndex(x=>x.value == item.idpeso);
            var idmasa = this.Masa[indexmasa].idclave;
            var weight = 0;

            if(idmasa == 'KL1'){//Libras a Kilogramos
                weight = item.weight; 
            }
            if(idmasa == 'TN1'){//Toneladas a Kilogramos
                weight = parseFloat(item.weight / 1000).toFixed(2); 
            }
            if(idmasa == 'GR1'){//Gramos a Kilogramos
                weight = parseFloat(item.weight * 1000).toFixed(2); 
            }
            if(idmasa == 'LI1'){//Libras a Kilogramos
                weight = parseFloat(item.weight / 0.453592).toFixed(2); 
            }

             Object.assign(this.editpackage,{
                idspackage:item.idspackage,
                Notes: item.Notes,
                activo: item.activo,
                actualweight: item.actualweight,
                high: high,
                idlongitud: item.idlongitud,
                idpackage: item.idpackage,
                idpeso:  item.idpeso,
                peso:item.idpeso,
                large:  large,
                longitud:  item.idlongitud,
                nhigh:  item.nhigh,
                nlarge:  item.nlarge,
                nstackable:  item.nstackable,
                nweight:  weight,
                nwidth:  item.nwidth,
                otropackage:  item.otropackage,
                package:  item.package,
                quantity:  item.quantity,
                stackable:  this.editpackage.stackable,
                volumetricweight:  item.volumetricweight,
                weight:  weight,
                width: width,
            });
        },
        editItemc(item){
            var edit = [];
            this.editedIndexc = this.containers.indexOf(item)
            var weight = 0;
            if(item.idunidadmasa != 1){
                weight = parseInt(item.weightsnconv);
            }else{
                weight = parseInt(item.weight);
            }
            Object.assign(this.editcontainer,{
                quantity:item.quantity,
                size:item.size,
                idsize:item.idsize,
                type:item.type,
                idtype:item.idtype,
                weight:item.weight,
                nweight:item.nweight,
                remarks:'',
                idunidadmasa:item.idunidadmasa,
                peso:item.idunidadmasa,
                weightsnconv:item.weightsnconv
            })
        },
        deleteItemc (item) {
           const index = this.containers.indexOf(item)
           var eliminar=[];
           var resp = confirm('Are you sure you want to delete this unit?');
           if(resp == true){
                this.containers[index].activo = false;
           }
        },
        deleteItempackage (item) {
           const index = this.addpackages.indexOf(item)
           var eliminar=[];
           var resp = confirm('Are you sure you want to delete this package?');
           if(resp == true){
                this.addpackages[index].activo = false;
           }
        },
        deletechargesell (item) {
           // console.log(item)
           const index = this.buysells.indexOf(item)
           var eliminar=[];
           var resp = confirm('Are you sure you want to delete this charge?');
           if(resp == true){
                this.buysells[index].activo = false;
           }
        },
        deletechargebuy (item) {
           const index = this.buysellB.indexOf(item)
           var eliminar=[];
           var resp = confirm('Are you sure you want to delete this charge?');
           if(resp == true){
                this.buysellB[index].activo = false;
           }
        },
        limpiarcontenedor(){
            this.editcontainer.quantity = '';
            this.editcontainer.idsize = '';
            this.editcontainer.idtype = '';
            this.editcontainer.peso = 1;
            this.editcontainer.weight  = '';
            this.editedIndexc = -1;
        },
        agregarbs(){
            let model=this;  
            var ivag;
            var tipocambio = parseFloat(this.editedbuysell.rate).toFixed(2);
            var mxn = 0;
        
            if(`${this.editedbuysell.idmoneda.text}` == 'MXN' || this.editedbuysell.idmoneda == 2){
                mxn = this.editedbuysell.rate
                tipocambio = parseFloat(tipocambio / this.editedbuysell.idtipocambio).toFixed(2);
            }
            if(this.editedbuysell.idper == 'Prepaid'){
                this.prepaid = tipocambio;
            }
            else{
                this.collect = tipocambio;
            }
            if(this.editedbuysell.idiva.value == undefined){
                if(this.editedbuysell.idiva == 2){
                    this.iva = parseFloat((parseFloat(0)/100) * tipocambio);
                }else{
                    this.iva = parseFloat((parseFloat(this.editedbuysell.ivacant)/100) * tipocambio);
                    if(this.editedbuysell.ivacant == undefined){
                        this.iva =  tipocambio * 0.16
                    }
                }
                ivag = this.editedbuysell.idiva
            }
            else{
                this.iva = parseFloat((parseFloat(`${this.editedbuysell.idiva.text}`)/100) * tipocambio);
                this.editedbuysell.ivacant = `${this.editedbuysell.idiva.text}`
                ivag = this.editedbuysell.idiva.value
            }
            var total = parseFloat(tipocambio) +  this.iva;
            var tamc;
            var tipoc;
            var tamanoc;
            var idtipoc;
            var idmoneda;
            var moneda;
            var tcambio;
            
            if(model.editedbuysell.idcontenedor.value == undefined){
                if(model.editedbuysell.idcontenedor == ''){
                    idtipoc = 15;
                    tipoc = '-';
                }else{
                    idtipoc = model.editedbuysell.idcontenedor;
                    tipoc = model.editedbuysell.tipoc;
                }
            }
            else
            {
                idtipoc = model.editedbuysell.idcontenedor.value;
                tipoc = `${this.editedbuysell.idcontenedor.text}`
            }
            
            if(model.editedbuysell.idtamano.value == undefined){
                if(tamc = model.editedbuysell.idtamano == ''){
                    tamc = 10;  
                    tamanoc = '-';
                }else{
                    tamc = model.editedbuysell.idtamano;  
                    tamanoc = model.editedbuysell.tamanoc;
                }
            }
            else
            {
                tamc = model.editedbuysell.idtamano.value;
                tamanoc = `${model.editedbuysell.idtamano.text}`;
            }
            if(model.editedbuysell.quantity == ''){
                model.editedbuysell.quantity = 0;
            }
            
            if(this.editedbuysell.idmoneda.value == undefined){
                idmoneda  = this.editedbuysell.idmoneda;
                moneda = 'USD';
                
            }
            else{
                idmoneda  = this.editedbuysell.idmoneda.value;
                moneda = this.editedbuysell.idmoneda.text;
            }
            if(this.editedbuysell.idmoneda.value == 1){
                this.idtc = 1;
            }
            if(this.editedbuysell.idmoneda == 1){
                tcambio = 1;
                this.idtc = 1;
            }
            else{
                tcambio = this.editedbuysell.idtipocambio
            }
            var buysell;
            var idbuysell;
            var provider;
            var idprovider;
            var idcharge;
            var charge;

            if(this.editedbuysell.idinstance.value == undefined){
                buysell = this.editedbuysell.buysell
                idbuysell = this.editedbuysell.idinstance
            }
            else{
                buysell = `${this.editedbuysell.idinstance.text}`
                idbuysell = this.editedbuysell.idinstance.value
            }
            if(this.editedbuysell.idprovider.value == undefined){
                provider = this.editedbuysell.provider
                idprovider = this.editedbuysell.idprovider
            }
            else{
                provider = `${this.editedbuysell.idprovider.text}`
                idprovider = this.editedbuysell.idprovider.value
            }
            if(this.editedbuysell.idcharge.value == undefined){
                charge =this.editedbuysell.charge;
                idcharge = this.editedbuysell.idcharge;
            }
            else{
                charge = `${this.editedbuysell.idcharge.text}`;
                idcharge = this.editedbuysell.idcharge.value;
            }
            if(this.validarbs()){
                return;
            }else{
                if(this.valida == 0){
                    if(provider == '' || idprovider == '' || idprovider == undefined || provider == undefined || this.editedbuysell.rate == '') {
                window.alert('Agregar todos los datos *');
                }else{
                    
                        if (this.editedIndexchb > -1 && this.editedIndexchs == -1) {
                            Object.assign(this.buysellB[this.editedIndexchb],{
                                buysell:buysell,
                                idinstance:idbuysell,
                                charge:charge,
                                idcharge:idcharge,
                                idprovider:idprovider,
                                provider:provider,
                                per:this.editedbuysell.payment,
                                idper:this.editedbuysell.idper,
                                payment:this.editedbuysell.payment,
                                idmoneda:idmoneda,
                                moneda:'USD',
                                prepaid:this.prepaid,
                                collect:this.collect,
                                notas:this.editedbuysell.notas,
                                idtamano:tamc,
                                tamanoc:tamanoc,
                                idcontenedor:idtipoc,
                                tipoc:tipoc,
                                idtipocambio:this.idtc,
                                rate:tcambio,
                                iva:parseFloat(this.iva).toFixed(2),
                                idiva:ivag,
                                total:parseFloat(total).toFixed(2),
                                totalmxn:mxn,
                                ivacant:this.editedbuysell.ivacant,
                                cobrarenpesos:this.cobrarpesos,
                                quantity:this.editedbuysell.quantity,
                                activo:true,
                            });
                            this.totalBuy = Number(this.totalBuy) + Number(total);
                            this.idtotalbuy1 = parseFloat(this.totalBuy).toFixed(2);
                            this.idtotalbuy = "$ " + this.addCommas(this.idtotalbuy1)
                            this.idtotal1 = parseFloat(this.idtotalsell1).toFixed(2) - parseFloat(this.idtotalbuy1).toFixed(2);
                            this.idtotal = parseFloat(this.idtotal1).toFixed(2);
                            this.idtotal = '$ ' + this.addCommas(this.idtotal)
                            this.limpiarcharge();
                        }
                        else {
                            if(`${this.editedbuysell.idinstance.text}` == 'Buy'){
                                this.buysellB.push({
                                    buysell:`${this.editedbuysell.idinstance.text}`,
                                    idinstance:this.editedbuysell.idinstance.value,
                                    charge:`${this.editedbuysell.idcharge.text}`,
                                    idcharge:this.editedbuysell.idcharge.value,
                                    idprovider:this.editedbuysell.idprovider.value,
                                    provider:`${this.editedbuysell.idprovider.text}`,
                                    per:this.editedbuysell.payment,
                                    idper:this.editedbuysell.idper,
                                    payment:this.editedbuysell.payment,
                                    idmoneda:idmoneda,
                                    moneda:'USD',
                                    prepaid:this.prepaid,
                                    collect:this.collect,
                                    notas:this.editedbuysell.notas,
                                    idtamano:tamc,
                                    tamanoc:tamanoc,
                                    idcontenedor:idtipoc,
                                    tipoc:tipoc,
                                    idtipocambio:this.idtc,
                                    rate:tcambio,
                                    iva:parseFloat(this.iva).toFixed(2),
                                    idiva:ivag,
                                    total:parseFloat(total).toFixed(2),
                                    totalmxn:mxn,
                                    ivacant:this.editedbuysell.ivacant,
                                    cobrarenpesos:this.cobrarpesos,
                                    quantity:this.editedbuysell.quantity,
                                    activo:true,
                                });
                                this.totalBuy = Number(this.totalBuy) + Number(total);
                                this.idtotalbuy1 = parseFloat(this.totalBuy).toFixed(2);
                                this.idtotalbuy = "$ " + this.addCommas(this.idtotalbuy1)
                            }
                        }
                        if (this.editedIndexchs > -1 && this.editedIndexchb == -1) {
                            Object.assign(this.buysells[this.editedIndexchs],{
                                buysell:buysell,
                                idinstance:idbuysell,
                                charge:charge,
                                idcharge:idcharge,
                                idprovider:idprovider,
                                provider:provider,
                                per:this.editedbuysell.payment,
                                idper:this.editedbuysell.idper,
                                payment:this.editedbuysell.payment,
                                idmoneda:idmoneda,
                                moneda:'USD',
                                prepaid:this.prepaid,
                                collect:this.collect,
                                notas:this.editedbuysell.notas,
                                idtamano:tamc,
                                tamanoc:tamanoc,
                                idcontenedor:idtipoc,
                                tipoc:tipoc,
                                idtipocambio:this.idtc,
                                rate:tcambio,
                                iva:parseFloat(this.iva).toFixed(2),
                                idiva:ivag,
                                total:parseFloat(total).toFixed(2),
                                totalmxn:mxn,
                                ivacant:this.editedbuysell.ivacant,
                                cobrarenpesos:this.cobrarpesos,
                                quantity:this.editedbuysell.quantity,
                                activo:true,
                            });
                            this.totalSell = Number(this.totalSell) + Number(total);
                            this.idtotalsell1 = parseFloat(this.totalSell).toFixed(2);
                            this.idtotalsell = '$ ' + this.addCommas(this.idtotalsell1)
                        }
                        else{
                            if(`${this.editedbuysell.idinstance.text}` == 'Sell'){
                                this.buysells.push({
                                    buysell:`${this.editedbuysell.idinstance.text}`,
                                    idinstance:this.editedbuysell.idinstance.value,
                                    charge:`${this.editedbuysell.idcharge.text}`,
                                    idcharge:this.editedbuysell.idcharge.value,
                                    idprovider:this.editedbuysell.idprovider.value,
                                    provider:`${this.editedbuysell.idprovider.text}`,
                                    per:this.editedbuysell.payment,
                                    idper:this.editedbuysell.idper,
                                    payment:this.editedbuysell.payment,
                                    idmoneda:idmoneda,
                                    moneda:'USD',
                                    prepaid:this.prepaid,
                                    collect:this.collect,
                                    notas:this.editedbuysell.notas,
                                    idtamano:tamc,
                                    tamanoc:tamanoc,
                                    idcontenedor:idtipoc,
                                    tipoc:tipoc,
                                    idtipocambio:this.idtc,
                                    rate:tcambio,
                                    iva:parseFloat(this.iva).toFixed(2),
                                    idiva:ivag,
                                    total:parseFloat(total).toFixed(2),
                                    totalmxn:mxn,
                                    ivacant:this.editedbuysell.ivacant,
                                    cobrarenpesos:this.cobrarpesos,
                                    quantity:this.editedbuysell.quantity,
                                    activo:true,
                                })
                                this.totalSell = Number(this.totalSell) + Number(total);
                                this.idtotalsell1 = parseFloat(this.totalSell).toFixed(2);
                                this.idtotalsell = '$ ' + this.addCommas(this.idtotalsell1)
                            }
                        }
                        this.idtotal1 = parseFloat(this.idtotalsell1).toFixed(2) - parseFloat(this.idtotalbuy1).toFixed(2);
                        this.idtotal = parseFloat(this.idtotal1).toFixed(2);
                        this.idtotal = '$ ' + this.addCommas(this.idtotal)
                        this.limpiarcharge();
                    }
                }                
            }
            
            

        },
        validarbs(){
            if(this.editedbuysell.payment == 'container'){
                if(this.editedbuysell.idtamano == 0 || this.editedbuysell.idcontenedor == 0 || this.editedbuysell.quantity <= 0){
                    window.alert('Favor de agregar cantidad, tipo o tamaño de contenedor')
                    this.valida=1;
                }else{
                    this.valida=0;
                }   
            }
            return this.validabs; 
        },
        GuardarCharges(){
            let header={"Authorization" : "Bearer " + this.$store.state.token};
                let configuracion ={headers:header};
                let model = this;       
                var ivag;
                var tamc;
                var tipoc;
                
                if(`${model.editedbuysell.idiva.value}`=='undefined'){
                    ivag = '2';    
                }else
                {
                    ivag = `${model.editedbuysell.idiva.value}`;
                }
                if(`${model.editedbuysell.idcontenedor.value}`=='undefined'){
                    tipoc = '15';    
                }else
                {
                    tipoc = `${model.editedbuysell.idcontenedor.value}`;
                }
                if(`${model.editedbuysell.idtamano.value}`=='undefined'){
                    tamc = '1002';    
                }else
                {
                    tamc = `${model.editedbuysell.idtamano.value}`;
                }
                if(model.editedbuysell.quantity == ''){
                    model.editedbuysell.quantity=0;
                }

            axios.post('api/ChargesBS/Crear',{                
                    'consecutivo':model.bsnum,    
                    'idinstance':  `${model.editedbuysell.idinstance.value}`,
                    'idcustomer':  model.editBS.idcustumer,
                    'idcharge': parseInt(`${model.editedbuysell.idcharge.value}`),
                    'idprovider': parseInt(`${model.editedbuysell.idprovider.value}`),
                    'idtipocambio': '1',
                    'idmoneda': `${model.editedbuysell.idmoneda.value}`,
                    'idiva': ivag,
                    'iva':parseFloat(model.iva).toFixed(2),
                    'total':model.idtotalbuy,
                    'prepaid': model.prepaid,
                    'collect': model.collect,
                    'payment': model.editedbuysell.payment,
                    'quantity': model.editedbuysell.quantity,
                    'idcontenedor': tipoc,
                    'idtamano': tamc,
                    'notas': model.editedbuysell.notas,
                },configuracion).then(function(response){
                }).catch(function(error){                                                
                    console.log(error); 
                });
        },
        editItemBSChB(item){
            this.cargarproveedores();
            this.editedIndexchb = this.buysellB.indexOf(item)
            var total=0;
            var idmoneda=0;
            var tc = 0;
            this.idtc = item.idtipocambio;
            if(item.totalmxn !=0){
                total = item.totalmxn
                idmoneda = 2;
                tc = item.rate;
            }else{
                if(item.prepaid != 0){
                    total=item.prepaid;
                }
                if(item.collect != 0){  
                    total=item.collect;
                }
                idmoneda = item.idmoneda;
                tc = 1;
            }
            Object.assign(this.editedbuysell,{
                buysell:item.buysell,
                idinstance:item.idinstance,
                charge:item.charge,
                idcharge:item.idcharge,
                idprovider:item.idprovider,
                provider:item.provider,
                per:item.per,
                idper:item.idper,
                payment:item.payment,
                idmoneda:idmoneda,
                moneda:item.moneda,
                prepaid:item.prepaid,
                collect:item.collect,
                notas:item.notas,
                idtamano:item.idtamano,
                tamanoc:item.tamanoc,
                idcontenedor:item.idcontenedor,
                tipoc:item.tipoc,
                idtipocambio:tc,
                rate:total,
                iva:item.iva,
                idiva:item.idiva,
                total:item.total,
                totalmxn:item.totalmxn,
                quantity:item.quantity,
                ivacant:item.ivacant,
            })
            this.cobrarpesos = item.cobrarenpesos;
            this.totalBuy = this.totalBuy - item.total;
            this.idtotalbuy = parseFloat(this.totalBuy).toFixed(2);
            this.idtotal1 = parseFloat(this.idtotalsell1).toFixed(2) - parseFloat(this.totalBuy).toFixed(2);
            this.idtotal = parseFloat(this.idtotal1).toFixed(2);
            this.idtotal = '$ ' + this.addCommas(this.idtotal)
        },
        editItemBSChS(item){
            this.cargarentities(this.editBS.idcustumer);
            this.editedIndexchs = this.buysells.indexOf(item)
            var total=0;
            var idmoneda=0;
            var tc = 0;
            this.idtc = item.idtipocambio;
            if(item.totalmxn !=0){
                total = item.totalmxn
                idmoneda = 2;
                tc = item.rate;
            }else{
                if(item.prepaid != 0){
                    total=item.prepaid;
                }
                if(item.collect != 0){  
                    total=item.collect;
                }
                idmoneda = item.idmoneda;
                tc = 1;
            }
            Object.assign(this.editedbuysell,{
                buysell:item.buysell,
                idinstance:item.idinstance,
                charge:item.charge,
                idcharge:item.idcharge,
                idprovider:item.idprovider,
                provider:item.provider,
                per:item.per,
                idper:item.idper,
                payment:item.payment,
                idmoneda:idmoneda,
                moneda:item.moneda,
                prepaid:item.prepaid,
                collect:item.collect,
                notas:item.notas,
                idtamano:item.idtamano,
                tamanoc:item.tamanoc,
                idcontenedor:item.idcontenedor,
                tipoc:item.tipoc,
                idtipocambio:tc,
                rate:total,
                iva:item.iva,
                idiva:item.idiva,
                total:item.total,
                totalmxn:item.totalmxn,
                cobrarenpesos:item.cobrarenpesos,
                quantity:item.quantity,
                ivacant:item.ivacant,
            })
            this.cobrarpesos = item.cobrarenpesos;
            this.totalSell = Number(this.totalSell) - Number(item.total);
            this.idtotalsell = parseFloat(this.totalSell).toFixed(2);
            this.idtotal1 = parseFloat(this.idtotalsell).toFixed(2) - parseFloat(this.idtotalbuy1).toFixed(2);
            this.idtotal = parseFloat(this.idtotal1).toFixed(2);
            this.idtotal = '$ ' + this.addCommas(this.idtotal)
        },
        editItem(item) {
            this.editedIndexbs = this.buysells.indexOf(item)
            this.editedbuysell = Object.assign({}, item)
            this.Tipocambio();
        },
        limpiarcharge(){
            this.editedbuysell.idinstance = 0;
            this.editedbuysell.idcharge = 0;
            this.editedbuysell.idprovider = 0;
            this.editedbuysell.idmoneda = 1;
            this.editedbuysell.rateex = 1;
            this.editedbuysell.rate = '';
            this.editedbuysell.idiva = 2;
            this.editedbuysell.idper = 'Prepaid';
            this.editedbuysell.payment = 'shipment';
            this.editedbuysell.quantity = '';
            this.editedbuysell.idtamanoc = 0;
            this.editedbuysell.idtamano = 0;
            this.editedbuysell.idtipoc = 0;
            this.editedbuysell.notes = '';
            this.editedbuysell.prepaid = 0;
            this.editedbuysell.collect = 0;
            this.editedbuysell.total = 0;
            this.editedbuysell.notas = '';
            this.editedbuysell.idtipocambio = 1;
            this.editedbuysell.idcontenedor  = 0;
            this.editedIndexbs = -1;
            this.editedIndexchb = -1;
            this.editedIndexchs = -1
            this.prepaid = 0;
            this.collect = 0;
            this.cobrarpesos = false;
        },       
        NumCons(){
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            let me=this;          
            var consecutivoArray = [];            
            axios.get('api/Consecutivos/Select',configuracion).then(function(response){            
                consecutivoArray=response.data;
                consecutivoArray.map(function(x){
                    me.consecutivo.push({text:x.consecutivo,value:x.idconsecutivo});                    
                });                      
            }).catch(function(error){
            console.log(error);
            });
        },
        consecutivos(){
            let me=this;
            var fecha = new Date();
            var year = fecha.getFullYear();
            me.cons = me.Numconsecutivo + 1;
            var ceros;
            if (me.cons <= 9) {
                ceros = "0000";
            }
            if (me.cons >= 99){
                ceros = "000";
            }
            if (me.cons >= 999) {
                ceros = "00";
            }
            if (me.cons >= 9999)
            {
                ceros = "0";                
            }
            if (me.cons >= 99999)
            {
                ceros = "";
            }
            me.bsnum = 'BS' + year + ceros + me.cons;
           // console.log(me.bsnum);
        },
        activaaereo(){
            this.aereo = false;
            if(this.editBS.idmodalidad == 2){
                this.aereo = true;
            }
        },
        activar(){        
                this.PACKAGES = false;
                this.CONTAINER = false;
                this.activevgm = true;
                this.activecust = false;
                this.ftldate = false;
                this.inland = true;
                this.lclview = false;
                this.titleprov = 'Shipping Line';
                this.titlePortloading = 'Port of loading',
                this.titlePortdischarge = 'Port of discharge',
                this.viewtransfer= false;
                this.viewfreedays=false;
                this.viewinland = false;
                this.viewfahscode = false;
                this.viewqt = false;
                this.viewportdischarge = false;
                this.viewunits = false;
                this.viewportloading = false;
                this.viewprovidertranser = true;
            if(this.editBS.idmodalidad != 0){
                this.activarbasis = false
            }
            if(this.editBS.idbasis  == 1){//FCL
                this.activecust = true;
                this.CONTAINER = true;
               // console.log(this.editBS.idtipoOp )
                if (this.editBS.idinland != 0) {
                    this.inland = false;
                }   
                if(this.editBS.idtipoOp == 2){//EXPO
                    this.activevgm = false;
                }
            }            
            if(this.editBS.idbasis  == 2){
              this.activecust = true;
              this.PACKAGES = true;
              this.viewtransfer= true;
                if (this.editBS.idinland != 0) {
                    this.inland = false;
                }
            }            
            if(this.editBS.idbasis  == 3 || this.editBS.idbasis  == 4){
                this.viewportloading = true;
                this.CONTAINER = true;
                this.titleprov = 'Provider';
                this.viewinland = true;
                this.viewfahscode = true;
                this.viewqt = true;
                this.viewportdischarge = true;
                this.viewfreedays = true;
                this.inland = false;
                this.ftldate = false;

                if(this.editBS.idbasis == 4){
                   this.CONTAINER = false;
                   this.activecust = true;
                    this.PACKAGES = true;
                    this.viewtransfer= true;
                }
            }
            if(this.editBS.idbasis  == 5){//aereo
                this.activecust = true;
                this.titleprov = 'AirLine / Provider';
                this.titlePortloading ='AOL';
                this.titlePortdischarge='AOD';
                this.PACKAGES = true;
                this.viewfreedays = false;      
                this.viewtransfer = true;
                if (this.editBS.idinland != 0) {
                    this.inland = false;
                }          
            }     
        },
        addCommas(nStr) {
            nStr += '';
            var x = nStr.split('.');
            var x1 = x[0];
            var x2 = x.length > 1 ? '.' + x[1] : '';
            var rgx = /(\d+)(\d{3})/;
            while (rgx.test(x1)) {
                x1 = x1.replace(rgx, '$1' + ',' + '$2');
            }
            return x1 + x2;
        },
        /*----------------------------------*/
        mostrarotro(){
            if(this.editpackage.idpackage.value == 1002){
                this.packageotro = true;
            }else{
                this.packageotro = false;
            }
        },
        nuevabs(){
            this.limpiar();
            this.$refs.form.resetValidation();
            //this.mostrarcampos = true;
        },
        /***********************/
        viewoscar(){
            if(this.editBS.idbasis == 3 || this.editBS.idbasis == 4){
                this.InlandExists(this.editBS.idbs);
            }else{
                this.OscarExists(this.editBS.idbs);
            }
            this.informaciondeembarque();
        },
        InlandExists(id){
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            var InlandDatos;
            var idinland;
            me.numoscar = 'Pendiente';
            axios.get('api/InlandDatos/ListarInland/'+id,configuracion).then(function(response){                
                InlandDatos=response.data;
                InlandDatos.map(function(x){
                    me.numoscar = x.ninland,
                    idinland = x.idinland
                });
                if(InlandDatos.length > 0){
                    me.CargarInformacionIn(idinland,1)
                }else{
                    me.CargarInformacionIn(me.editBS.idbs,2)
                }
                
                me.ListarChargeBST(me.editBS.idbs)
            }).catch(function(error){
                console.log(error);
            }); 
        },
        OscarExists(id){
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            var oscar = [];
            var idoscar;
            this.numoscar = 'Pendiente';
            axios.get('api/Oscars/buscaroscar/'+ id,configuracion).then(async function(response){                
                oscar = response.data;
                    oscar.map(function(x){
                        me.numoscar = x.numoscar,
                        idoscar = x.idoscar
                    })
                    if(oscar.length > 0){
                        me.CargarInformacion(idoscar,1);
                        me.viewoscarbs = true
                    }else{
                        me.CargarInformacion(me.editBS.idbs,2);
                        me.viewbsbs = true;
                    }
                    me.ListarChargeBST(me.editBS.idbs)
                }).catch(function(error){
                    console.log(error);
                });
        },
        async CargarInformacion(id,generado){
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            var container = [];
             me.tarifasListar = [];
             me.infcontainers = [];
            if(generado == 1){
                axios.get('api/Containers_pack_oscar_ogl/ListarContainersOscar/'+ id,configuracion).then(async function(response){                
                container=response.data;
                    var i;
                    var idsize = 0;
                    var idtype = 0;
                    for(i = 0; i < container.length; i++){
                        me.infcontainers.push({
                            number:container.length,
                            idsize:container[i].idsize,
                            idtype:container[i].idtype,
                            weight:'',
                        });
                        idsize = container[i].idsize;
                        idtype = container[i].idtype;
                        me.tarifasListar.push({
                            num:i+1,
                            idcontainer:container[i].idcontainer,
                            qty:container[i].qty,
                            idpackage:container[i].idpackage,
                            size:container[i].size,
                            type:container[i].type,
                            idsize:container[i].idsize,
                            idtype:container[i].idtype,
                            qtycontainers:container[i].qtycontainers,
                            containernumber:container[i].containernumber,
                            sel:container[i].sel,
                            vol:container[i].vol,
                            ngross:me.addCommas(parseFloat(container[i].gross).toFixed(2)) + " Kg.",
                            gross:container[i].gross,
                            hbln:container[i].hbln,
                            idhbl:container[i].idhbl,
                            idhbln:container[i].idhbln,
                            mbln:container[i].mbln,
                            idmbl:container[i].idmbl,
                            idmbln:container[i].idmbln,
                            description:container[i].description,
                            length:container[i].length,
                            width:container[i].width,
                            height:container[i].height,
                            activo:true,
                        })
                    }
                    me.cargarinfocontainer();
                }).catch(function(error){
                    console.log(error);
                });            
            }
            else
            {
                axios.get('api/DatosContainerUnits/ListarContainersBs/'+ id + '/' + 1,configuracion).then(async function(response){
                container = response.data;
                    var i;
                    container.map(async function(x){
                         me.infcontainers.push({
                            number:x.quantity,
                            idsize:x.idsize,
                            idtype:x.idtype,
                            weight:me.addCommas(x.weight),
                        });
                        for(i = 0; i < x.quantity; i++){
                            me.tarifasListar.push({
                                num:i+1,
                                qty:'',
                                idpackage:0,
                                size:x.size,
                                type:x.type,
                                idsize:x.idsize,
                                idtype:x.idtype,
                                qtycontainers:'',
                                containernumber:'',
                                description:'',
                                sel:'',
                                vol:'',
                                idhbln:'',
                                ngross:me.addCommas(parseFloat(x.weight).toFixed(2)) + " Kg.",
                                gross:x.weight,
                                hbln:'',
                                idhbl:0,
                                idmbln:'',
                                mbln:'',
                                idmbl:0,
                                length:0,
                                width:0,
                                height:0,
                                activo:true,
                            })
                        }
                    });
                    me.cargarinfocontainer();
                }).catch(function(error){
                    console.log(error);
                });
            }  
        },
        async cargarinfocontainer(){
            this.tarifasListarinfo = [];
            var i=0;
            for(i = 0; i < this.tarifasListar.length; i++){
                if(this.tarifasListar[i].activo == true){
                    this.tarifasListarinfo.push({
                        num:this.tarifasListar[i].num,
                        qty:this.tarifasListar[i].qty,
                        idpackage:this.tarifasListar[i].idpackage,
                        idpackagen:this.tarifasListar[i].idpackagen,
                        package:this.tarifasListar[i].idpackagen,
                        size:this.tarifasListar[i].size,
                        type:this.tarifasListar[i].type,
                        idsize:this.tarifasListar[i].idsize,
                        idtype:this.tarifasListar[i].idtype,
                        qtycontainers:this.tarifasListar[i].qtycontainers,
                        containernumber:this.tarifasListar[i].containernumber,
                        sel:this.tarifasListar[i].sel,
                        vol:this.tarifasListar[i].vol,
                        ngross:this.addCommas(parseFloat(this.tarifasListar[i].gross).toFixed(2)) + " Kg.",
                        gross:this.tarifasListar[i].gross,
                        hbln:this.tarifasListar[i].hbln,
                        idhbl:this.tarifasListar[i].idhbl,
                        idhbln:this.tarifasListar[i].idhbln,
                        mbln:this.tarifasListar[i].mbln,
                        idmbl:this.tarifasListar[i].idmbl,
                        idmbln:this.tarifasListar[i].idmbln,
                        description:this.tarifasListar[i].description,
                        length:this.tarifasListar[i].length,
                        width:this.tarifasListar[i].width,
                        height:this.tarifasListar[i].height,
                        activo:true,
                    })
                }
            }
        },
        async informaciondeembarque(){
            this.dialodload=true;
            var i = 0;
            var j = 0;
            var hbl='';
            var hb = '';
            var mb = '';
            var hbc = '';
            var mbc = '';
            var containernumber='';
            var container = [];
            this.hblnum='';
            this.ncontainer ='';
            this.numbercontainer='';
            this.mblhnl = [];
            var nueva = false;
            for(i = 0; i< this.tarifasListar.length; i++){
                if(this.tarifasListar[i].hbln != ''){
                    if(this.tarifasListar[i].hbln != hbl){
                        if(this.hblnum == ''){
                            this.hblnum = this.tarifasListar[i].hbln;
                        }else{
                            this.hblnum = this.hblnum + ' / ' + this.tarifasListar[i].hbln; 
                        }
                    }
                }
                if(this.tarifasListar[i].containernumber != ''){
                    if(this.tarifasListar[i].containernumber != containernumber){
                        if(this.numbercontainer == ''){
                            this.numbercontainer = this.tarifasListar[i].containernumber;
                        }else{
                            this.numbercontainer = this.numbercontainer + ' / ' + this.tarifasListar[i].containernumber; 
                        }
                    }
                }
                if(container.length > 0){
                    for(j=0; j < container.length; j++){
                        if(container[j].size == this.tarifasListar[i].size){
                            Object.assign(container[j], {
                                cat:container[j].cat + 1,
                                size:this.tarifasListar[i].size,
                                type:this.tarifasListar[i].type,
                            });
                        }else{
                            if(nueva == false){
                                container.push({
                                    cat:0,
                                    size:this.tarifasListar[i].size,
                                    type:this.tarifasListar[i].type,
                                })
                                nueva = true;
                            }
                        }
                    }
                }else{
                    container.push({
                        cat:1,
                        size:this.tarifasListar[i].size,
                        type:this.tarifasListar[i].type,
                    })
                }
                hbl = this.tarifasListar[i].hbln;
                containernumber = this.tarifasListar[i].containernumber;
                if(this.tarifasListar[i].hbln != ''|| this.tarifasListar[i].mbln != ''){
                    if(this.tarifasListar[i].hbln != hb || this.tarifasListar[i].mbln != mb){
                        if(this.tarifasListar[i].idhbln != hbc || this.tarifasListar[i].idmbln != mbc){
                            this.mblhnl.push({
                                hbln:this.tarifasListar[i].hbln,
                                idhbln:this.tarifasListar[i].idhbln,
                                mbln:this.tarifasListar[i].mbln,
                                idmbln: this.tarifasListar[i].idmbln
                            })
                        }
                    }

                }
                hb = this.tarifasListar[i].hbln;
                hbc = this.tarifasListar[i].idhbln;
                mb = this.tarifasListar[i].mbln;
                mbc = this.tarifasListar[i].idmbln

            }
            var k = 0;
            var prefix='';
            for(k=0; k < container.length; k++ ){
                if(container[k].type == 'DRY CARGO'){
                    prefix='DC';
                }
                if(container[k].type == 'HIGH CUBE'){
                    prefix='HC';
                }
                if(prefix ==''){
                    prefix = container[k].type;
                }
                if(this.ncontainer == ''){
                    this.ncontainer = container[k].cat + 'x'+ container[k].size +' ' +prefix    
                }else{
                    this.ncontainer = this.ncontainer + ' / '+ container[k].cat + 'x'+ container[k].size +' ' +prefix
                }
            }
        },
        async ListarChargeBST(idbs){
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            let me=this; 
            var buy=[];
            var sell=[]
            var i;
            var n;
            var tbuy = 0;
            var tsell = 0;
            var total = 0;
            var tbuyiva = 0;
            var tselliva = 0;
            var totaliva = 0;
            me.totalsell = 0;
            me.totalbuy = 0;
            me.totalprofit = 0;
            me.totalselliva = 0;
            me.totalbuyiva = 0;
            me.totalprofitiva = 0;
            me.costossell = [];
            var an=0;
            var ans=0;
            setTimeout(function(){
                axios.get('api/chargesBS/ListarChargesBuy/' + idbs,configuracion).then(async function(response){
                    buy=response.data;
                    me.buysellBt = [];
                    buy.map(async function(x){
                        var totalmxn = 0;
                        if(x.cobrarenpesos == true){
                            totalmxn = me.addCommas(x.totalmxn);
                        } 
                        if(x.payment == 'container'){
                            var nconcainer;
                            an = an + 1;
                            var TotalC = 0;
                            var ncontainer = 0;
                            var TotalMxnC = 0;
                            var ivan = 0;

                                if(x.quantity >= 1){
                                    ncontainer = x.quantity;
                                }else{
                                    ncontainer = me.infcontainers.length;
                                }                                

                                TotalC = ncontainer * x.total;
                                TotalMxnC = ncontainer * x.totalmxn;
                                ivan = ncontainer * x.iva;

                            me.buysellBt.push({
                                num:an,
                                buysell:x.buysell,
                                charge:x.charge,
                                collect:me.addCommas(x.collect),
                                collectn:me.addCommas(x.collect).toString(),
                                idbs:x.idbs,
                                idcharge:x.idcharge,
                                idchargebs:x.idchargebs,
                                idcontenedor:x.idcontenedor,
                                idcustomer:x.idcustomer,
                                idinstance:x.idinstance,
                                idiva:x.idiva,
                                idmoneda:x.idmoneda,
                                idprovider:x.idprovider,
                                idtamano:x.idtamano,
                                idtipocambio:x.idtipocambio,
                                iva:me.addCommas(ivan),
                                ivan:me.addCommas(ivan).toString(),
                                moneda:x.moneda,
                                notas:x.notas,
                                per:x.payment,
                                payment:x.payment,
                                prepaidn:me.addCommas(x.prepaid).toString(),
                                prepaid:me.addCommas(x.prepaid),
                                provider:x.provider,
                                quantity:ncontainer,
                                rate:x.rate,
                                tamanoc:x.tamanoc,
                                tipoc:x.tipoc,
                                total:me.addCommas(TotalC),
                                totalmxn:TotalMxnC,    
                                totalmxnn:me.addCommas(TotalMxnC).toString(),
                                totaln:me.addCommas(TotalC).toString(),
                                invoice:x.invoice,
                            });
                            
                            tbuyiva = Number(tbuyiva) + Number(TotalC);
                            if(x.prepaid != 0){
                                tbuy = Number(tbuy) + Number(x.prepaid * ncontainer);
                            }
                            if(x.collect != 0){
                                tbuy = Number(tbuy) + Number(x.collect * ncontainer);
                            }   
                        }else{
                            if(x.payment == 'TON/m3'){
                                var costo;
                                var iva;   
                                var total;  
                                
                                if(me.pesovolumen >= me.actualw){
                                    if(x.prepaid !=''){
                                        costo = me.pesovolumen * x.prepaid;
                                    }else{
                                        costo = me.pesovolumen * x.collect;
                                    }
                                }else{
                                    if(x.prepaid !=''){
                                        costo = me.actualw * x.prepaid;
                                    }else{
                                        costo = me.actualw * x.collect;
                                    }
                                }
                                iva = Number(costo) * 0.16;
                                total = Number(costo) + Number(iva);
                                an = an + 1;
                                me.buysellBt.push({
                                    num:an,
                                    buysell:x.buysell,
                                    charge:x.charge,
                                    collect:me.addCommas(x.collect),
                                    collectn:me.addCommas(x.collect).toString(),
                                    idbs:x.idbs,
                                    idcharge:x.idcharge,
                                    idchargebs:x.idchargebs,
                                    idcontenedor:x.idcontenedor,
                                    idcustomer:x.idcustomer,
                                    idinstance:x.idinstance,
                                    idiva:x.idiva,
                                    idmoneda:x.idmoneda,
                                    idprovider:x.idprovider,
                                    idtamano:x.idtamano,
                                    idtipocambio:x.idtipocambio,
                                    iva:me.addCommas(x.iva),
                                    ivan:me.addCommas(x.iva).toString(),
                                    moneda:x.moneda,
                                    notas:x.notas,
                                    per:x.payment,
                                    payment:x.payment,
                                    prepaid:me.addCommas(x.prepaid),
                                    prepaidn:me.addCommas(x.prepaid).toString(),
                                    provider:x.provider,
                                    quantity:x.quantity,
                                    rate:x.rate,
                                    tamanoc:x.tamanoc,
                                    tipoc:x.tipoc,
                                    total:me.addCommas(total),
                                    totalmxn:totalmxn,
                                    totalmxnn:me.addCommas(totalmxn).toString(),
                                    totaln:me.addCommas(x.total).toString(),
                                    invoice:x.invoice,
                                });
                            }else{
                                an = an + 1;
                                me.buysellBt.push({
                                    num:an,
                                    buysell:x.buysell,
                                    charge:x.charge,
                                    collect:me.addCommas(x.collect),
                                    collectn:me.addCommas(x.collect).toString(),
                                    idbs:x.idbs,
                                    idcharge:x.idcharge,
                                    idchargebs:x.idchargebs,
                                    idcontenedor:x.idcontenedor,
                                    idcustomer:x.idcustomer,
                                    idinstance:x.idinstance,
                                    idiva:x.idiva,
                                    idmoneda:x.idmoneda,
                                    idprovider:x.idprovider,
                                    idtamano:x.idtamano,
                                    idtipocambio:x.idtipocambio,
                                    iva:me.addCommas(x.iva),
                                    ivan:me.addCommas(x.iva).toString(),
                                    moneda:x.moneda,
                                    notas:x.notas,
                                    per:x.payment,
                                    payment:x.payment,
                                    prepaid:me.addCommas(x.prepaid),
                                    prepaidn:me.addCommas(x.prepaid).toString(),
                                    provider:x.provider,
                                    quantity:x.quantity,
                                    rate:x.rate,
                                    tamanoc:x.tamanoc,
                                    tipoc:x.tipoc,
                                    total:me.addCommas(x.total),
                                    totalmxn:totalmxn,
                                    totalmxnn:me.addCommas(totalmxn).toString(),
                                    totaln:me.addCommas(x.total).toString(),
                                    invoice:x.invoice,
                                });
                            }
                            tbuyiva = Number(tbuyiva) + Number(x.total);
                            if(x.prepaid != 0){
                                tbuy = Number(tbuy) + Number(x.prepaid);
                            }
                            if(x.collect != 0){
                                tbuy = Number(tbuy) + Number(x.collect);
                            }
                        }
                    });
                    me.totalbuyiva = parseFloat(Number(tbuyiva)).toFixed(2);
                    me.totalbuy = parseFloat(Number(tbuy)).toFixed(2);
                    axios.get('api/chargesBS/ListarChargesSell/' + idbs,configuracion).then(async function(response){
                        sell=response.data;
                        me.costossell = response.data;
                        var fin = 0;
                        me.buysellst = [];
                        sell.map(async function(x){
                            var totalmxn = 0;
                            if(x.cobrarenpesos == true){
                                totalmxn = me.addCommas(x.totalmxn);
                            }
                            if(x.payment == 'container'){
                                ans = ans + 1;
                                var TotalC = 0;
                                var ncontainer = 0;
                                var TotalMxnC = 0;
                                var ivan = 0;
                                if(x.quantity >= 1){
                                    ncontainer = x.quantity;
                                }else{
                                    ncontainer = me.infcontainers.length;
                                }
                                TotalC = ncontainer * x.total;
                                TotalMxnC = ncontainer * x.totalmxn;
                                ivan = ncontainer * x.iva;

                                me.buysellst.push({
                                    num:ans,
                                    buysell:x.buysell,
                                    charge:x.charge,
                                    collect:me.addCommas(x.collect),
                                    collectn:me.addCommas(x.collect).toString(),
                                    idbs:x.idbs,
                                    idcharge:x.idcharge,
                                    idchargebs:x.idchargebs,
                                    idcontenedor:x.idcontenedor,
                                    idcustomer:x.idcustomer,
                                    idinstance:x.idinstance,
                                    idiva:x.idiva,
                                    idmoneda:x.idmoneda,
                                    idprovider:x.idprovider,
                                    idtamano:x.idtamano,
                                    idtipocambio:x.idtipocambio,
                                    iva:me.addCommas(ivan),
                                    ivan:me.addCommas(ivan).toString(),
                                    moneda:x.moneda,
                                    notas:x.notas,
                                    per:x.payment,
                                    payment:x.payment,
                                    prepaid:me.addCommas(x.prepaid),
                                    prepaidn:me.addCommas(x.prepaid).toString(),
                                    provider:x.provider,
                                    quantity:x.quantity,
                                    rate:x.rate,
                                    tamanoc:x.tamanoc,
                                    tipoc:x.tipoc,
                                    ntotal:x.total,
                                    total:me.addCommas(TotalC),
                                    quantity:ncontainer,
                                    totalmxn:TotalMxnC,
                                    totalmxnn:me.addCommas(TotalMxnC).toString(),
                                    totaln:me.addCommas(TotalC).toString(),
                                    invoice:x.invoice,
                                });
                                tselliva = Number(tselliva) + Number(TotalC);
                                if(x.prepaid != 0){
                                    tsell = Number(tsell) + Number(x.prepaid * ncontainer);
                                }
                                if(x.collect != 0){
                                    tsell = Number(tsell) + Number(x.collect * ncontainer);
                                }
                            }else{
                                if(x.payment == 'TON/m3'){
                                        var costo;
                                        var iva;   
                                        var total;  
                                        
                                        if(me.pesovolumen >= me.actualw){
                                            if(x.prepaid !=''){
                                                costo = me.pesovolumen * x.prepaid;
                                            }else{
                                                costo = me.pesovolumen * x.collect;
                                            }
                                        }else{
                                            if(x.prepaid !=''){
                                                costo = me.actualw * x.prepaid;
                                            }else{
                                                costo = me.actualw * x.collect;
                                            }
                                        }
                                        iva = Number(costo) * 0.16;
                                        total = Number(costo) + Number(iva);
                                        an = an + 1;
                                        me.buysellst.push({
                                            num:ans,
                                            buysell:x.buysell,
                                            charge:x.charge,
                                            collect:me.addCommas(x.collect),
                                            collectn:me.addCommas(x.collect).toString(),
                                            idbs:x.idbs,
                                            idcharge:x.idcharge,
                                            idchargebs:x.idchargebs,
                                            idcontenedor:x.idcontenedor,
                                            idcustomer:x.idcustomer,
                                            idinstance:x.idinstance,
                                            idiva:x.idiva,
                                            idmoneda:x.idmoneda,
                                            idprovider:x.idprovider,
                                            idtamano:x.idtamano,
                                            idtipocambio:x.idtipocambio,
                                            iva:me.addCommas(x.iva),
                                            ivan:me.addCommas(x.iva).toString(),
                                            moneda:x.moneda,
                                            notas:x.notas,
                                            per:x.payment,
                                            payment:x.payment,
                                            prepaid:me.addCommas(x.prepaid),
                                            prepaidn:me.addCommas(x.prepaid).toString(),
                                            provider:x.provider,
                                            quantity:x.quantity,
                                            rate:x.rate,
                                            tamanoc:x.tamanoc,
                                            tipoc:x.tipoc,
                                            ntotal:x.total,
                                            total:me.addCommas(total),
                                            totalmxn:totalmxn,
                                            totalmxnn:me.addCommas(totalmxn).toString(),
                                            totaln:me.addCommas(x.total).toString(),
                                            invoice:x.invoice,
                                        });
                                        tselliva = Number(tselliva) + Number(x.total);
                                        if(x.prepaid != 0){
                                            tsell = Number(tsell) + Number(x.prepaid);
                                        }
                                        if(x.collect != 0){
                                            tsell = Number(tsell) + Number(x.collect);
                                        }
                                }else{
                                    ans = ans + 1;
                                    me.buysellst.push({
                                        num:ans,
                                        buysell:x.buysell,
                                        charge:x.charge,
                                        collect:me.addCommas(x.collect),
                                        collectn:me.addCommas(x.collect).toString(),
                                        idbs:x.idbs,
                                        idcharge:x.idcharge,
                                        idchargebs:x.idchargebs,
                                        idcontenedor:x.idcontenedor,
                                        idcustomer:x.idcustomer,
                                        idinstance:x.idinstance,
                                        idiva:x.idiva,
                                        idmoneda:x.idmoneda,
                                        idprovider:x.idprovider,
                                        idtamano:x.idtamano,
                                        idtipocambio:x.idtipocambio,
                                        iva:me.addCommas(x.iva),
                                        ivan:me.addCommas(x.iva).toString(),
                                        moneda:x.moneda,
                                        notas:x.notas,
                                        per:x.payment,
                                        payment:x.payment,
                                        prepaid:me.addCommas(x.prepaid),
                                        prepaidn:me.addCommas(x.prepaid).toString(),
                                        provider:x.provider,
                                        quantity:x.quantity,
                                        rate:x.rate,
                                        tamanoc:x.tamanoc,
                                        tipoc:x.tipoc,
                                        ntotal:x.total,
                                        total:me.addCommas(x.total),
                                        totaln:me.addCommas(x.total).toString(),
                                        totalmxn:totalmxn,
                                        totalmxnn:me.addCommas(totalmxn).toString(),
                                        invoice:x.invoice,
                                    });
                                    tselliva = Number(tselliva) + Number(x.total);
                                    if(x.prepaid != 0){
                                        tsell = Number(tsell) + Number(x.prepaid);
                                    }
                                    if(x.collect != 0){
                                        tsell = Number(tsell) + Number(x.collect);
                                    }
                                }   
                            }
                            fin = fin + 1;
                        });
                                        
                        me.totalselliva = parseFloat(Number(tselliva)).toFixed(2);
                        me.totalsell = parseFloat(Number(tsell)).toFixed(2);

                        if(sell.length == fin){
                            me.totalf(); 
                        }
                    }).catch(function(error){
                        console.log(error);
                    });
                    }).catch(function(error){
                        console.log(error);
                    });
            },0 | Math.random() * 2500);
        },

        async totalf(){
            this.totalprofitiva = Number(this.totalselliva) - Number(this.totalbuyiva);
            this.totalselliva = this.addCommas(parseFloat(Number(this.totalselliva)).toFixed(2));
            this.totalbuyiva = this.addCommas(parseFloat(Number(this.totalbuyiva)).toFixed(2));
            this.totalprofitiva = this.addCommas(parseFloat(Number(this.totalprofitiva)).toFixed(2));

            this.totalprofit = Number(this.totalsell) - Number(this.totalbuy);
            await this.actiualizarprofit(this.totalbuy,this.totalsell,this.totalprofit);
            this.totalsell = this.addCommas(parseFloat(Number(this.totalsell)).toFixed(2));
            this.totalbuy = this.addCommas(parseFloat(Number(this.totalbuy)).toFixed(2));
            this.totalprofit = this.addCommas(parseFloat(Number(this.totalprofit)).toFixed(2));
            this.dialodload=false;
            this.dialof = true;
            
        },
        actiualizarprofit(compra,venta,profit){
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            var info = false;

            if(this.numoscar != "Pendiente"){
                info = true;
            }
            axios.put('api/Buysells/ActualizarProfit',{
                'idbs':this.editBS.idbs,
                'ventat':venta,
                'comprat':compra,
                'profitt':profit,
                'info':info
            },configuracion).then(function(response){        
                console.log('correcto')
            }).catch(function(error){
                console.log(error);
            });  
        },
        CargarInformacionIn(id,generdo){
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            var container = [];
            me.infcontainers = [];
            me.tarifasListar = [];
            if(generdo == 1)
            {
                axios.get('api/InlandUnits/ListarContainers/'+ id,configuracion).then(function(response){
                    container=response.data;
                    var i = 0;
                    var n = 0;
                    var  size = 0;
                    container.map(function(x){
                        n = n + 1;
                        me.tarifasListar.push({
                                idinlandunit:x.idinlandunit,
                                idcontainer:x.idcontainer,
                                idpackage:'',
                                idpackagen:'',
                                num:n,
                                qty:n,
                                size:x.size,
                                type:x.type,
                                idsize:x.idsize,
                                idtype:x.idtype,
                                containernumber:x.equipmentnumber,
                                sel:x.seal,
                                vol:x.volumen,
                                grossweight:me.addCommas(x.grossweight) ,
                                comentarios:'',
                                hbln:'',
                                idhbl:0,
                                idmbln:'',
                                mbln:'',
                                idmbl:0,
                                activo:true,
                            })
                            //if(size != x.idsize){
                            //    console.log('entra container info')
                                me.infcontainers.push({
                                    idcontainer:x.idcontainer,
                                    number:container.length,
                                    idsize:x.idsize,
                                    idtype:x.idtype,
                                    weight:me.addCommas(x.grossweight),
                                });
                                size = x.idsize;
                            //}
                        i = i + 1;
                        //me.containerunit.push({text:x.size + " " + x.type ,value:x.idcontainer});
                    }) 
                    //me.ListarChargeBST(me.editBS.idbs);
                    me.cargarinfocontainer()
                }).catch(function(error){
                    console.log(error);
                });
            }else{                
                axios.get('api/DatosContainerUnits/ListarContainersBs/'+ id ,configuracion).then(function(response){                
                container=response.data;
                var i;
                var n = 0;
                container.map(function(x){
                    for(i = 0; i < x.quantity; i++){
                    me.infcontainers.push({
                        idcontainer:x.idcontainer,
                        number:x.quantity,
                        idsize:x.idsize,
                        idtype:x.idtype,
                        weight:me.addCommas(x.weight),
                    });
                     me.inlandst.push({
                            idcontainer:x.idcontainer,
                            num:n,
                            qty:i+1,
                            size:x.size,
                            type:x.type,
                            idsize:x.idsize,
                            idtype:x.idtype,
                            enumber:'',
                            seal:'',
                            volumen:'',
                            grossweight:me.addCommas(x.weight),
                            comentarios:'',
                            activo:true,
                        })
                        n= n + 1;
                    }
                    //me.containerunit.push({text:x.size + " " + x.type ,value:x.idcontainer});
                })    
            }).catch(function(error){
                    console.log(error);
                });
            }
        },
    },
}
</script>
